import {ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {MatDialog, MatDialogContainer} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {ActivatedRoute, RouterOutlet} from '@angular/router';
import {MsalService} from "@azure/msal-angular";
import {interval, map, Observable, startWith, Subscription} from 'rxjs';
import {GestionPeticionWebComponent} from './GestionPeticiones/gestion-peticion-web/gestion-peticion-web.component';
import {AlertArgumentarioComponent} from '../VistasGenericas/alert-argumentario/alert-argumentario.component';
import {GestionArticulo} from './articulo/GestionArticulo';
import {BuscadorTallerComponent} from './buscador-taller/buscador-taller.component';
import {BuscarPeticionComponent} from './buscar-peticion/buscar-peticion.component';
import {BusquedaMatriculaComponent} from './busqueda-matricula/busqueda-matricula.component';
import {calculateDNILetter} from './helpers/dni-utils';
import {GestionHoja} from './hoja/GestionHoja';
import {AnexoDelegacion} from './models/AnexoDelegacion';
import {ArticuloContact} from './models/ArticuloContact';
import {ArticuloMO} from './models/ArticuloMO';
import {Asegurado} from './models/Asegurado';
import {BusArtCallcenter} from './models/BusArtCallcenter';
import {Cliente} from './models/Cliente';
import {Hoja} from './models/Hoja';
import {CallCenter, InsCallCenter} from './models/InsCallCenter';
import {Llamada} from './models/Llamada';
import {Persona} from './models/Persona';
import {RBMatriculaMin} from './models/RBMatricula';
import {Vehiculo} from './models/Vehiculo';
import {BdService} from './services/bd.service';
import {ClienteService} from './services/bd/Cliente/cliente.service';
import {PersonesService} from './services/bd/Cliente/persones.service';
import {DelegacionService} from './services/bd/Delegacion/delegacion.service';
import {AlbaranTallService} from './services/bd/Hoja/albaran-tall.service';
import {HojaService} from './services/bd/Hoja/hoja.service';
import {ArticuloService} from './services/bd/articulo/articulo.service';
import {BuscadorArticuloService} from './services/buscador-articulo.service';
import {UsuarioService} from './services/user.service';
import {PilotosFunctions} from './functionDefinitions/Pilotos';
import {Tabla, TablasService} from "./services/bd/Tablas/tablas.service";
import {AudaService} from "./services/auda/auda.service";
import {GestionPeticionAlpComponent} from "./GestionPeticiones/gestion-peticion-alp/gestion-peticion-alp.component";
import {AxaComponent} from "./axa/axa.component";
import {GlassTalleresComponent} from "./glass-talleres/glass-talleres.component";
import {AbancaComponent} from "./abanca/abanca.component";
import {ApiService} from "./services/api.service";
import {AgentsService} from "./services/bd/Agents/agents.service";
import {CampasFunctions} from "./functionDefinitions/CheckCampas";
import {ComponentType} from "@angular/cdk/overlay";
import {CpTallerService} from "./services/bd/Delegacion/cp-taller.service";
import {FuncionesExterno} from "../externo/funciones-Externo";
import {HttpClient} from "@angular/common/http";
import { RolService } from '../Middleware/rol.service';
import {RolCallCenter} from './models/RolCallCenter';
import {environment} from "../../environments/environment";
import {BookingService} from "./services/bd/Booking/booking.service";
import { EmailService } from './services/email.service';
import { VerificacionMutuaDialogComponent } from './verificacion-mutua-dialog/verificacion-mutua-dialog.component';
import {MutuaService} from './services/mutua.service';
import { SiniestroExtraDialogComponent } from './mutua-siniestroextradialog-component/siniestro-extra-dialog.component';

@Component({
  selector: 'ral-hojas-call-center',
  templateUrl: './hojas-call-center.component.html',
  styleUrls: ['./hojas-call-center.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Default,
})

export class HojasCallCenterComponent implements OnInit, OnDestroy
{
  intentosAutovalid  = 0;
  enabledSin: boolean = false;
  showObtenerSiniestro: boolean = false;
  showSiebel: boolean = false;
  showPelayo: boolean = false;
  showMapfre: boolean = false;
  showMussap: boolean = false;
  showAxa: boolean = false;
  showAllianz: boolean = false;
  showTrabajos: boolean = false;
  showEntidad: boolean = false;
  showCampa: boolean = false;
  busquedaAuda: boolean = true;
  busquedaArticulos: boolean = true;
  firstEntry: boolean = true;
  disableBtnGuardar: boolean = true;
  seGuardaHoja: boolean = false;

  /*
  *  Condiciones botonera abajo CC
  */

  showemailLD: boolean = true;
  showGestionweb: boolean = true;
  showGestionAlp: boolean = true;
  showGestionMobili: boolean = true;
  showGestionVarias: boolean = true;
  showGestionDrivalia: boolean = true;
  showGestionRauda: boolean = true;
  showOutbound: boolean = true;
  showGestionnuevaWeb: boolean = true;
  showSegurCaixa: boolean = true;


  mensajeAvisoTalles: string = "";
  prefixEntidad: string = "";
  mensajeObser: string = "";
  auxCia: string = ""; // variable necesaria para seleccionar cia automaticamente
  token:string = "";
  idtrans: string = "0"; //Id transacción enviado por parametro por Vodafone desde Softphone
  callCampana: string = ""; //Si hay campaña activa en algun piloto se cambiara este campo para guardar la llamada.
  idlinea: string = "";
  habGestionVarias : boolean = false;
  idgestionweb: string = "";
  idservicios: string = "";
  idcorredor: string = "";
  idAlphabet: string = "";
  idIncid: string = "";
  cpllamada: string = "";

  auxSusLloc: string = "";
  auxRepa: number = 0;

  recomendadoList: Tabla[] = [];
  entradaLlamadasList: Tabla[] = [];
  tipoLlamadaList: Tabla[] = [];
  origenLlamadaList : Tabla[] = [];
  obserLlamadaList : Tabla [] = [];
  descSiniestroList: Tabla [] = [];
  entidadList: Tabla [] = [];
  cias : Cliente[] = [];

  yearsMatriculacion : number[] = [];
  emailFacilitado:string ="si";
  asegurado:Asegurado = new Asegurado();
  llamada : Llamada = new Llamada();
  vehiculo:Vehiculo = new Vehiculo();
  infoSiniestroExtra = {
    lugar: '',
    como: ''
  };
  getInfoSiniestroFormateada(): string {
  const lugar = this.infoSiniestroExtra.lugar?.trim() || '';
  const como = this.infoSiniestroExtra.como?.trim() || '';
  if (!lugar && !como) return '';
  return `LUGAR: ${lugar} | COMO: ${como}`;
  }
  direccion : string = "";
  kmDireccion:number = 80;
  selectAdas: string = "NO";

  displayedColumns: string[] = ['eurocode', 'articulo', 'descripcion', 'observaciones','stkcen','stktall','stkReg','oem'];
  columnasArtSeleccionados: string[] = ['eurocode', 'articulo', 'descripcion', 'observaciones','cen','tall','reg','btn'];
  usuariosAutorizados: string[] = ["nalcarria", "alarrea", "nhayati","mduenas","acano", "rluque", "sgranados","arodriguez", "bvite","eginfarre", "szalla", "mmartinez", "acruz", "iforradellas", "vagudo", "vdiaz", "kalvarez", "cchicano"];
  colores : string[] = ["","AMARILLO","AZUL","BEIGE","BLANCO","GRIS","MARRON","NEGRO","PLATA","ROJO","VERDE"];

  artsSeleccionados : ArticuloContact[]=[];
  artsSeleccionadosSource = new MatTableDataSource(this.artsSeleccionados);

  artsVacio: any[] = ["", ""];
  artsVacioSource  = new MatTableDataSource(this.artsVacio);

  talleresDisponibles:AnexoDelegacion[] = [];
  talleresDisponiblesControl = new FormControl('');
  talleresDisponiblesF:Observable<AnexoDelegacion[]> = new Observable<AnexoDelegacion[]>();

  tallerSeleccionado:AnexoDelegacion|null = null;
  tipoTaller: string = "";
  avisosTaller:string = "";//MUESTRA los avisos del taller seleccionado
  previousTallerSeleccionado: any;

  ciasDisponiblesControl = new FormControl('');
  ciasDisponiblesF:Observable<Cliente[]>=new Observable<Cliente[]>();
  previousCiaSeleccionada: any;
  ciaSeleccionada:Cliente|null = null;

  asegurados : Persona[] = [];
  aseguradosDisponiblesF:Observable<Persona[]> = new Observable<Persona[]>();


  marcasDisponibles : string[] = [];
  modelosDisponibles : string[] = [];
  modeloSeleccionado: string = "";
  trabajoSeleccionado: string = "";
  danosPrismaCodigos: string[] = [];
  latitud:number=0;
  longitud:number=0;
  entidadSeleccionada: string = "";

  puertasVehiculo:number[] = [];

  ocultarBuscaMatricula:boolean=true;
  ocultarBuscaCliente:boolean=true;

  //el usuario actual
  usuario:string="";

  extranjera: boolean = false;

  manoObraArticulos:ArticuloMO[]=[];
  campanaArticulos: ArticuloContact[] = [];
  bookingArticulos: ArticuloContact[] = [];

  realizarPeticiones: boolean = true;
  respEmail: string[] = [];

  campaContactRls: string = "";
  auxCampaCC: string = ""; // Auxiliar para que no se rellene el campo campaContactRLS cuando es opcional.
  //*FormControls de la vista
  emailFormControl = new FormControl('',[Validators.email]);
  telefono1FormControl = new FormControl('', [Validators.pattern(/^\d{9}$/)]);
  telefono2FormControl = new FormControl('', [Validators.pattern(/^\d{9}$/)]);
  matriculaFormControl = new FormControl('', [
    Validators.pattern(/^([0-9]{4}[A-Z]{3})$|^([A-Z]{1,2}[0-9]{4}[A-Z]{1,2})$|^([H][0-9]{4}[A-Z]{3})$|^([A-Z]{1,2}[0-9]{4,6}VE)$|^([A-Z][0-9]{4}[A-Z]{3})$|^((PGC|CNP|ET|EA|TN|CGPC|CME|E)[0-9]{4}[A-Z]{0,2})$|^([MAF]{2,3}[0-9]{5})$|^([A-Z]{2}[0-9]{3}[A-Z]{3})$|^((CD|TA|OI|CC)[0-9]{5})$|^((S|V|FV|P)[0-9]{4}[A-Z]{3})$|^([A-Z][0-9]{6})$|^([A-Z]{2}[0-9]{5})$|^(E[0-9]{4}[A-Z]{3})$|^([A-Z]{3,4}[0-9]{4}[A-Z])$|^([A-Z]{2}[0-9]{6})$|^(C[0-9]{4}[B-Z]{3})$|^(E[.\·][0-9]{4})$|^([E-Z][A-Z][0-9]{4}[A-Z])$|^([E-Z][A-Z][0-9]{4}[A-Z]{2})$|^([A-Z]{1,2}00[0-9]{4}[A-Z]{1,2})$/)
  ]);
  hojaGuardada: string = "";
  diccionarioEntidadFunciones: {[key: string]: () => void;} = {
    "121668": () => PilotosFunctions.entidadGeneral(this,"EA"),
    "137241": () => PilotosFunctions.entidadGeneral(this,"EA"),
    "127406": () => {this.mensajeObser = "Revisar datos CIA."},
    "135121": () => PilotosFunctions.addArticulo(this, "70004190", "NANOTRATAMIENTO ANTILLUVIA 500ML."),
    "120095": () => PilotosFunctions.entidadCaser(this),
    "121250": () => PilotosFunctions.entidadGeneral(this,"ER"),
    "136514": () => PilotosFunctions.entidadGeneral(this,"ER"),
    "120205": () => {PilotosFunctions.textoSiniestro(this); this.showMapfre = true},
    "140334": () => PilotosFunctions.entidadAxa(this),
    "122373": () => PilotosFunctions.entidadArval(this),
    "120122": () => {PilotosFunctions.textoSiniestro(this); this.showObtenerSiniestro= false;},
    "121446": () => {PilotosFunctions.textoSiniestro(this); this.showObtenerSiniestro= false;},
    "121630": () => PilotosFunctions.entidadGeneral(this,"EH"),
    "144625": () => {this.showObtenerSiniestro = true;},
    "009999": () => {this.showTrabajos = true;},
    "141687": () => PilotosFunctions.entidadAllianz(this), // TODO esta verificación deberia estar en otro lado
    "else": () => PilotosFunctions.entidadElse(this)
  }
  diccionarioFuncionesPiloto: {[key: string]: () => void;} = {
    "100000120": () => PilotosFunctions.comboQuien3(this),
    "200000053": () => PilotosFunctions.comboQuien3(this),
    "100000105": () => PilotosFunctions.comboQuien3(this),
    "200000064": () => PilotosFunctions.comboQuien3(this),
    "200000063": () => PilotosFunctions.comboQuien3(this),
    "100000049": () => PilotosFunctions.comboQuien3(this),
    "": () => PilotosFunctions.comboQuien3(this),
    "100000020": () => PilotosFunctions.comboQuien3(this),
    "100000050": () => PilotosFunctions.comboQuien3(this),
    "100000089": () => PilotosFunctions.comboQuien3(this),
    "200000057": () => PilotosFunctions.comboQuien3(this),
    "100000013": () => {PilotosFunctions.comboQuien2(this); PilotosFunctions.ponerCia(this, "ALD Automotive");},
    "100000063": () => PilotosFunctions.comboQuien2(this),
    "100000032": () => {PilotosFunctions.comboQuien2(this); PilotosFunctions.ponerCia(this, "SEGURCAIXA");},
    "100000016": () => {PilotosFunctions.comboQuien2(this);  PilotosFunctions.ponerCia(this, "121668");},
    "100000014": () => {PilotosFunctions.comboQuien2(this); this.showAllianz = true;},
    "100000021": () => {PilotosFunctions.comboQuien2(this); PilotosFunctions.textoSiniestro(this); PilotosFunctions.ponerCia(this, "LEASE PLAN SERVICIOS");},
    "100000036": () => PilotosFunctions.comboQuien2(this),
    "100000025": () => {PilotosFunctions.comboQuien2(this); PilotosFunctions.ponerCia(this, "MAPFRE ESPAÑOLA"); this.showMapfre = true},
    "100000019": () => {PilotosFunctions.comboQuien2(this); PilotosFunctions.ponerCia(this, "CASER(CIA");},
    "100000042": () => {PilotosFunctions.comboQuien2(this); PilotosFunctions.ponerCia(this, "HELLO INSURANCE GROUP");},
    "100000033": () => PilotosFunctions.caseRACC(this),
    "100000037": () => PilotosFunctions.caseRACC(this),
    "200000049": () => PilotosFunctions.comboQuien2(this),
    "100000075": () => {PilotosFunctions.comboQuien2(this); PilotosFunctions.ponerCia(this, "ALPHABET");},
    "100000022": () => PilotosFunctions.comboQuien1(this),
    "100000039": () => PilotosFunctions.comboQuien4(this),
    "100000058": () => PilotosFunctions.comboQuien4(this),
    "100000041": () => PilotosFunctions.comboQuien7(this),
    "100000040": () => PilotosFunctions.caseGeneraliRepa(this),
    "100000114": () => PilotosFunctions.textoSiniestro(this),
    "100000015": () => PilotosFunctions.caseAsefa(this),
    "100000026": () => PilotosFunctions.caseMapfre(this),
    "100000031": () => PilotosFunctions.caseRepa(this),
    "100000018": () => PilotosFunctions.caseAxa(this),
    "100000028": () => PilotosFunctions.caseNorthgate(this),
    "100000035": () => PilotosFunctions.caseAbanca(this),
    "100000012": () => PilotosFunctions.caseBBVA(this),
    "100000059": () => PilotosFunctions.caseCorredores(this),
    "100000027": () => PilotosFunctions.caseMussap(this),
    "100000029": () => PilotosFunctions.casePelayo(this),
    //"100000034": () => PilotosFunctions.caseFraiking(this),
    "100000024": () => PilotosFunctions.caseHibu(this),
    "100000068": () => PilotosFunctions.caseCentauro(this),
    "100000070": () => PilotosFunctions.caseEnterprise(this),
    "200000047": () => PilotosFunctions.caseAvis(this),
    "100000017": () => PilotosFunctions.caseAlquiber(this),
    "100000052": () => PilotosFunctions.caseWebLaminado(this),
    "100000057": () => PilotosFunctions.caseWebElevalunas(this),
    "100000043": () => PilotosFunctions.caseProyectos(this),
    "100000045": () => PilotosFunctions.caseAdwords(this),
    "100000044": () => PilotosFunctions.caseMetropolis(this),
    "100000091": () => PilotosFunctions.caseCampana(this),
    "100000038": () => PilotosFunctions.caseAlphabet(this),
    "100000034": () => PilotosFunctions.caseMobilize(this),
    "100000082": () => PilotosFunctions.caseArval(this),
    "100000095": () => PilotosFunctions.caseArval(this),
    "100000123": () => {PilotosFunctions.casePrima(this); this.showObtenerSiniestro= true;},
    "200000055": () => PilotosFunctions.caseUrquiabas(this),
    "100000118": () => PilotosFunctions.caseLeasePlan(this),
    "100000116": () => PilotosFunctions.caseAllianz(this),
    "200000105": () => PilotosFunctions.caseUNICAL(this),
    "200000104": () => PilotosFunctions.caseDrivalia(this),
    "200000101": () => PilotosFunctions.ponerCia(this, "141160"),
    "200000059": () => {PilotosFunctions.ponerCia(this, "CONTADOS"); PilotosFunctions.addArticulo(this, "70004174", "KIT RESTAURADOR DE FAROS")},
    "200000062": () => {PilotosFunctions.ponerCia(this, "CONTADOS"); PilotosFunctions.addArticulo(this, "50009999", "ESCOBILLAS ESPORADICO")},
    "else": () => PilotosFunctions.caseElse(this),
  }
  /*
  *  Parametros o variables utilizadas para el proyecto de Booking Plataform
  * */
  diccionarioTraduccionCristal: {[key: string]: string;} = {
    "FRONT REPAIR":"REPARACIÓN DE PARABRISAS",
    "FRONT REPLACE":"SUSTITUCIÓN DE PARABRISAS",
    "BACKCENTER REPLACE":"SUSTITUCIÓN LUNETA TRASERA",
    "BACKLEFT REPLACE":"SUSTITUCIÓN LUNETA TRASERA IZQUIERDA",
    "BACKRIGHT REPLACE":"SUSTITUCIÓN LUNETA TRASERA DERECHA",
    "FRONTQUARTERLEFT REPLACE":"SUSTITUCIÓN LUNA CUSTODIA DELANTERA IZQUIERDA",
    "FRONTQUARTERRIGHT REPLACE":"SUSTITUCIÓN LUNA CUSTODIA DELANTERA DERECHA",
    "FRONTLEFT REPLACE":"SUSTITUCIÓN DESCENDENTE DELANTERO IZQUIERDO",
    "FRONTRIGHT REPLACE":"SUSTITUCIÓN DESCENDENTE DELANTERO DERECHO",
    "FRONTVENTLEFT REPLACE":"SUSTITUCIÓN FIJO DELANTERO IZQUIERDO",
    "FRONTVENTRIGHT REPLACE":"SUSTITUCIÓN FIJO DELANTERO DERECHO",
    "MIDDLELEFT REPLACE":"SUSTITUCIÓN LATERAL CENTRAL IZQUIERDO",
    "MIDDLERIGHT REPLACE":"SUSTITUCIÓN LATERAL CENTRAL DERECHO",
    "MIDDLEQUARTERLEFT REPLACE":"SUSTITUCIÓN LUNA CUSTODIA CENTRAL IZQUIERDA",
    "MIDDLEQUARTERRIGHT REPLACE":"SUSTITUCIÓN LUNA CUSTODIA CENTRAL DERECHA",
    "REARQUARTERLEFT REPLACE":"SUSTITUCIÓN COSTADO TRASERO IZQUIERDO",
    "REARQUARTERRIGHT REPLACE":"SUSTITUCIÓN COSTADO TRASERO DERECHO",
    "REARLEFT REPLACE":"SUSTITUCIÓN DESCENDENTE TRASERO IZQUIERDO",
    "REARRIGHT REPLACE":"SUSTITUCIÓN DESCENDENTE TRASERO DERECHO",
    "REARVENTLEFT REPLACE":"SUSTITUCIÓN FIJO TRASERO IZQUIERDO",
    "REARVENTRIGHT REPLACE":"SUSTITUCIÓN FIJO TRASERO DERECHO",
    "ROOF REPLACE":"SUSTITUCIÓN TECHO PANORÁMICO",
    "UNKNOWN REPLACE":"OTRO"
  }
  
  caseID: string = "";
  tallerBooking: boolean = false;
  fechaCitaBooking: string = "";
  horaCitaBooking: string = "";
  pickupDateBooking: string = "";
  tieneCitaReservada: boolean = false;

  private subscription: Subscription | undefined;
  private flagSinCoberturaMutua: boolean = false;
  public cambioCompaniaAutomatica = false;
  

  @ViewChild('routerOutlet', { static: true }) routerOutlet!: RouterOutlet;
  private peticionRealizada: string = "NO";
  private readonly NOMBRE_APLICACION: string = "HojasCallCenter";
  rolUsuario:RolCallCenter|undefined = undefined;

  bloqueoTuVoz: boolean = false;
  //Trabajos en los que se omite la fecha cita (solo si es booking)
  public trabajosOmisionCita: string[] = ["OTRO","OTROS","SUSTITUCION TECHO SOLAR","DESCONOCIDO"];
  public clienteCita: string[] = ["137241", "116048", "134845", "134947"]
  public clientesMutua: string[] = ["128968", "135486", "144442"]
  public clientesGlassTalleres: string[] = ["120079", "120093", "120205", "128231", "128338", "133279", "143411", "144816",];

  get showGlassTalleres(): boolean {
    const cliente = (this.ciaSeleccionada?.cliente || '').toString().trim();
    return this.clientesGlassTalleres.includes(cliente);
  }

  // Variables para la obtención de articulo de forma periódica
  private pollTimeoutId: ReturnType<typeof setTimeout> | null = null;
  private stopFlag = true;  // empieza parado
  private pollingActivo = false;
  tienePermisoMutua: boolean = false;

  constructor
  (
    private Bd:BdService,
    private tablas: TablasService,
    private delegacionService:DelegacionService,
    private msalService: MsalService,
    public  dialog:MatDialog,
    private userService:UsuarioService,
    private clienteService:ClienteService,
    private personaService:PersonesService,
    public articuloService:ArticuloService,
    private buscadorService:BuscadorArticuloService,
    private albaranTallService:AlbaranTallService,
    private hojaService : HojaService,
    private route : ActivatedRoute,
    private audaService: AudaService,
    private api: ApiService,
    private rls: AgentsService,
    private cp: CpTallerService,
    private http: HttpClient,
    private roleService: RolService,
    private bookingService: BookingService,
    private mutuaService: MutuaService,
    private emailService: EmailService,
  ){
    this.previousTallerSeleccionado = "";
    this.previousCiaSeleccionada = "";
    let fechaPorDefecto = new Date();
    let mes = fechaPorDefecto.getMonth() + 1;
    let dia = fechaPorDefecto.getDate();
    let ano = fechaPorDefecto.getFullYear();
    this.asegurado.fecSin = `${ano}-${mes.toString().padStart(2, '0')}-${dia.toString().padStart(2, '0')}`;
  }

  /*
    * Recupera el rol del usuario en la aplicación y lo almacena en la variable rolUsuario
    * Si no tiene rol, tras la búsqueda de rol, la función termina.
    *
    * Si tiene rol, se comprueba datos_carga
    * Por cada elemento que este como ocultar, se ocultará el elemento correspondiente.
    * Estos elementos deben de referenciar a elementos de la template de html.
    *
    * @return void
  */
  comprobarRol(): void
  {
    //BUscamos si el usuario tiene algun rol establecido para esta aplicacion
    this.roleService.getRolAplicationUser(this.token,this.NOMBRE_APLICACION,this.usuario)
    .then(res =>
    {
      if(res.length>0)
      {
        this.rolUsuario = RolCallCenter.rolCallCenter(res[0]);
        if(this.rolUsuario.piloto.length>0)
        {
          /*
            * TENEMOS QUE CAMBIAR EL PILOTO SELECCIONADO DE ESTA MANERA!!!.
            * si hacemos this.llamada.entrada= this.rolUsuario.piloto, no se actualiza bien los procesos que se desencadenan
          */
          //TENEMOS QUE  buscar cada PILOTO en la BD
          this.tablas.getValoresTablasConcretos
          (
            "PO",
            this.token,
            ["codi", "descripcio", "trim(dades) as dades"],
            ["descripcio", "asc"],
            this.rolUsuario.piloto
          )
          .then((res: Tabla[]) =>
          {
            //asignamos los pilotos al array de entradaLlamadasList
            this.entradaLlamadasList = res;
            this.onEntradaLlamadaSelected(this.rolUsuario!.piloto[0]);
            this.bloqueoTuVoz = true;

            // Hacemos que sea SOLO seleccionable el piloto que tiene el usuario
            Object.keys(this.rolUsuario!.showBotones)
            .forEach(key =>
            {
              if (this.hasOwnProperty(key))
              {
                // Asigna el valor de showBotones[key] al atributo dinámico
                (this as any)[key] = this.rolUsuario!.showBotones[key];
              }
            });
          });
        }
      }
    })
  }


  ngOnDestroy(): void
  {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }


  async ngOnInit(): Promise<void>
  {
    try
    {
      await this.getAccessTokenPromise();
      this.getUsuarioToken();
      this.desMatriculaControl();
      let anyoI = new Date().getFullYear();
      while(anyoI>=1972)
      {
        this.yearsMatriculacion.push(anyoI)
        anyoI --;
      }

      await Promise.all([this.cargarCombosTablas()]).then(
          res =>
          {
            // Mira si hay parametros en la url para saber si viene de Alysis
            this.route.paramMap.subscribe(
                params=>
                {
                  const piloto = params.get('piloto');
                  if (piloto){
                    if (["100000051", "100000055", "100000053", "100000063", "100000064", "100000054"].includes(piloto.toString())){
                      window.close();
                      this.mostrarArgumentario("Atención",["Por favor, cierra esta ventana manualmente, ya que para este piloto no es necesario realizar hoja."]);
                    }else{
                      this.onEntradaLlamadaSelected(piloto.toString().trim());
                    }
                  }
                  const id = params.get('id');
                  if (id){
                    this.idtrans = id;
                  }
                })
          });
      this._agregarEscuchas();
      this.cargarMarcas();
      this.asegurado.servicio = "taller";
      this.vehiculo.color = "AMARILLO";
      this.comprobarRol();
    }
    catch (error)
    {
      console.error(error);
    }
  }

  getUsuarioToken(){
      if (localStorage.getItem("accessToken") != null){
          FuncionesExterno.getDataUser(this.token, this.http)
              .then((response: any) => {

                  this.usuario = response.userPrincipalName.split("@")[0];
              });
      }else{
          this.usuario = this.userService.getNombreCuenta();
      }
  }

  getAccessTokenPromise():Promise<void>
  {
    return new Promise((resolve, reject) =>
    {
        if (localStorage.getItem("accessToken") != null){
            this.token = localStorage.getItem("accessToken")!.toString();
            resolve();
        }else{
            this.msalService.acquireTokenSilent({ scopes: ['GroupMember.Read.All'] })
                .subscribe(
                    resultado => {
                        this.token = resultado.accessToken;
                        resolve();
                    },
                    error => {reject(error);}
                );
        }
    });
  }

  desMatriculaControl(){
    if (this.extranjera) {
      this.matriculaFormControl.clearValidators();
    } else {
      this.matriculaFormControl.setValidators([
        Validators.pattern(/^([0-9]{4}[A-Z]{3})$|^([A-Z]{1,2}[0-9]{4}[A-Z]{1,2})$|^([H][0-9]{4}[A-Z]{3})$|^([A-Z]{1,2}[0-9]{4,6}VE)$|^([A-Z][0-9]{4}[A-Z]{3})$|^((PGC|CNP|ET|EA|TN|CGPC|CME|E)[0-9]{4}[A-Z]{0,2})$|^([MAF]{2,3}[0-9]{5})$|^([A-Z]{2}[0-9]{3}[A-Z]{3})$|^((CD|TA|OI|CC)[0-9]{5})$|^((S|V|FV|P)[0-9]{4}[A-Z]{3})$|^([A-Z][0-9]{6})$|^([A-Z]{2}[0-9]{5})$|^(E[0-9]{4}[A-Z]{3})$|^([A-Z]{3,4}[0-9]{4}[A-Z])$|^([A-Z]{2}[0-9]{6})$|^(C[0-9]{4}[B-Z]{3})$|^(E[.\·][0-9]{4})$|^([E-Z][A-Z][0-9]{4}[A-Z])$|^([E-Z][A-Z][0-9]{4}[A-Z]{2})$|^([A-Z]{1,2}00[0-9]{4}[A-Z]{1,2})$/)
      ]);
    }
    this.matriculaFormControl.updateValueAndValidity();
  }

  /*
  * Carga de los combos del front segun el prefijo de tabla.
  */
  async cargarCombosTablas(): Promise<void>
  {
    let select = ["codi", "descripcio"];
    await Promise.all([
      this.rellenarComboTabla(this.recomendadoList,"QR", select),
      this.rellenarComboTabla(this.entradaLlamadasList,"PO", ["codi", "descripcio", "trim(dades) as dades"], ["descripcio", "asc"]),
      this.rellenarComboTabla(this.tipoLlamadaList,"TO", select),
      this.rellenarComboTabla(this.origenLlamadaList,"OG", ["lpad(codi,2,'0') as codi", "descripcio"]),
      this.rellenarComboTabla(this.obserLlamadaList,"OS", ["lpad(codi,2,'0') as codi", "dades as descripcio"]),
      this.rellenarComboTabla(this.descSiniestroList,"DO",["lpad(codi,2,'0') as codi", "descripcio"])
    ]);
    let currentYear: number = new Date().getFullYear();
    for (let i = currentYear; i >= 1970; i--)
    {this.yearsMatriculacion.push(i);}
    this.entradaLlamadasList.sort((a,b) => a.descripcio.localeCompare(b.descripcio));
  }

  /**
   * Rellena un array con los valores de una tabla dada.
   * @param array Array a rellenar.
   * @param prefijo Prefijo de la tabla.
   * @param select Campos a seleccionar.
   * @param orden Orden de los resultados.
   */
  rellenarComboTabla(array: Tabla[], prefijo: string, select: string[], orden: string[] = ["codi", "asc"]): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.tablas.getValoresTablas(prefijo, this.token,select, orden)
          .then(res => {
            res.forEach(element => {
              array.push(element);
            });
            array.sort();
            resolve();
          })
          .catch(error => reject(error));
    });
  }

  /**
   * Guarda una llamada entrante en el sistema.
   */
  guardarLlamadaEntrante(llamada_gt = false): Promise<void>
  {
    let origen: string = (this.llamada.origen || '').trim();
    let tipo: string = (this.llamada.tipo || '').trim();
    let piloto = (this.llamada.entrada || '').trim();

    if (llamada_gt) {
      if (!tipo) { tipo = '140'; }
      if (!origen) { origen = '01'; }
    }

    if(origen && tipo && piloto){
      if(tipo == "100" && this.cpllamada.trim() == ""){
        if (!llamada_gt) {
          this.mostrarArgumentario("Atención",["Es obligatorio indicar el codigo postal"], false, true, true);
        }
        return Promise.resolve();
      }else if(this.cpllamada.trim() != "" && this.cpllamada.length != 5){
        if (!llamada_gt) {
          this.mostrarArgumentario("Atención",["El codigo postal debe de tiene 5 caracteres"], false, true, true);
        }
        return Promise.resolve();
      }else{
        let ahora = this.getFechaHora();

        let fecha = ahora[0];
        let hora =  ahora[1];
        // Convertir a mayúsculas, eliminar puntos y obtener los primeros 70 caracteres
        let obser: string = this.llamada.observ.trim().toUpperCase().replace(/\./g, '').substring(0, 70);
        let idTrans: string = this.idtrans.trim();
        let campa: string = this.callCampana.trim();
        let cp_llamada: string = this.cpllamada.trim();

        if((piloto == "100000063" || piloto == "100000024") && obser == ""){
          if (!llamada_gt) {
            this.mostrarArgumentario("Atención",["En este piloto es obligatorio poner observaciones."], false, true, true);
          }
          return Promise.resolve();
        }else{

          this.asegurado.email == "" && this.emailFacilitado=="S"?this.emailFacilitado = "NF":this.emailFacilitado="S";
          let callcenter:CallCenter =
            {
              empresa:(this.tallerSeleccionado?this.tallerSeleccionado.delegacion:0),
              email_recogido:this.emailFacilitado,
              matricula:this.vehiculo.matricula,
              servicio:"",
              origen:origen,
              tipo:tipo,
              obser:obser,
              campa:campa,
              idtrans:Number.parseInt(idTrans),
              piloto:piloto,
              usuario:this.usuario,
              hora_hoja:hora,
              fecha_hoja:fecha,
              cp_llamada: cp_llamada
            }
          let callIns : InsCallCenter=
            {
              txtidlinea:this.idlinea,
              txtidgestionweb:this.idgestionweb,
              txtidservicios:this.idservicios,
              call:callcenter
            }
          try
          {
            return this.Bd.setLlamadaEntrante(this.token,callIns).then(
              res=>
              {
                if (!llamada_gt) {
                  var dialog = this.mostrarArgumentarioRes("Llamada guardada",["La llamada se ha guardado."]);
                  dialog.subscribe(() => {
                    location.reload();
                  });
                }
              }).catch(err=>{
                if (!llamada_gt) {
                  this.mostrarArgumentario("Error al guardar llamada",[err?.error?.title,err?.error?.message], false, true, true);
                }
              });
          }
          catch(ex){
            if (!llamada_gt) {
              this.mostrarArgumentario("Error al guardar llamada",[""+ex], false, true, true);
            }
            return Promise.resolve();
          }
        }
      }
    }else{
      if (!llamada_gt) {
        this.mostrarArgumentario("Atención",["Seleccionar piloto, origen y tipo de llamada para guardar."], false, true, true);
      }
      return Promise.resolve();
    }
  }

  getFechaHora():string[]
  {
    let now = new Date();
    let formattedDate = now.toISOString().slice(0,10);
    let formattedTime = now.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' ,second:'2-digit'});
    return[formattedDate,formattedTime];
  }

  mostrarArgumentario(titulo:string,lineas:string[],bloquearCierre:boolean=false,btnCierre:boolean=true, aviso: boolean=false):void
  {
    let clase = "normal-background";
    let color = "white"

    if (aviso){
      clase = "error-background";
      color = "#e8d9cf"
    }

    const dialogRef = this.dialog.open(AlertArgumentarioComponent,
        {
          data: {titulo: titulo,lineas:lineas, mostrarBtnCierre:btnCierre, msgError: aviso},
          disableClose:bloquearCierre//SI ES FALSE => permite cerrar al clicar fuera. SI es true , no puede (de esa manera)
        });

    dialogRef.addPanelClass(clase);
    // @ts-ignore
    this.getElementsByXPath("//*[contains(@class, '" + clase + "')]/mat-dialog-container/div/div")[0].style.backgroundColor =color;

    dialogRef.afterClosed()
        .subscribe(result =>
        {
        });
  }

  mostrarArgumentarioRes(titulo:string,lineas:string[],bloquearCierre:boolean=false,btnCierre:boolean=true, aviso: boolean=false):Observable<any>
  {
    let clase = "normal-background";
    let color = "white"

    if (aviso){
      clase = "error-background";
      color = "#e8d9cf"
    }

    const dialogRef = this.dialog.open(AlertArgumentarioComponent,
        {
          data: {titulo: titulo,lineas:lineas, mostrarBtnCierre:btnCierre, msgError: aviso},
          disableClose:bloquearCierre//SI ES FALSE => permite cerrar al clicar fuera. SI es true , no puede (de esa manera)
        });

    dialogRef.addPanelClass(clase);
    // @ts-ignore
    this.getElementsByXPath("//*[contains(@class, '" + clase + "')]/mat-dialog-container/div/div")[0].style.backgroundColor =color;

    return dialogRef.afterClosed()
  }

  //funcion unica y exclusivamente para personalizar el backgroun del MatDialog
  private getElementsByXPath(xpath:string)
  {
    let results = [];
    let query = document.evaluate(xpath, document,
        null, XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, null);
    for (let i = 0, length = query.snapshotLength; i < length; ++i) {
      results.push(query.snapshotItem(i));
    }
    return results;
  }

  allowOnlyNumbers(event: KeyboardEvent): void {
    const charCode = event.key.charCodeAt(0);
    if (charCode < 48 || charCode > 57) { // Rango ASCII para dígitos 0-9
      event.preventDefault();
    }
  }

  onEntradaLlamadaSelected(selectedValue: string, tallerPredeterminado: string = ""): void {
     
    this.ResetCaseID();

    //Verificamos si el piloto seleccionado es el que toca. 
    this.checkMutuaVerification();

    const dato = this.entradaLlamadasList.find(t => t.codi.toString().trim() == selectedValue.toString().trim());
    if (dato != null) {
      this.enabledSin = false;
      this.showObtenerSiniestro = false;
      this.showSiebel = false;
      this.showTrabajos = false;
      this.showMussap = false;
      this.showPelayo = false;
      this.showMapfre = false;
      this.showAxa = false;
      this.showAllianz = false;
      this.auxCia = "";

      this.llamada.entrada = dato.codi.trim();
      if (this.diccionarioFuncionesPiloto.hasOwnProperty(dato.codi.trim())) {
        this.diccionarioFuncionesPiloto[dato.codi.trim()]();
      } else {
        this.diccionarioFuncionesPiloto["else"]();
      }
      if (this.tipoTaller == ""){
        this.cargarListadoTalleres(dato.codi.trim(), tallerPredeterminado);
      }else if(this.tipoTaller == "mapfre"){
        this.cargarTallerMapfre();
      }else{
        this.cargarListadoTalleres(dato.codi.trim(), tallerPredeterminado);
      }


      if (this.previousCiaSeleccionada && this.auxCia != ""){
        this.auxCia = this.previousCiaSeleccionada.cliente;
        this.previousCiaSeleccionada = "";
        this.changeCia();
      }

      this.recargarTipo(dato.codi.trim());

      if (dato.dades.trim() != "") {
        let lineas: string[] = dato.dades.trim().split("\n")
        this.mostrarArgumentario(dato.descripcio.trim(), lineas);
      }

      if (this.asegurado.agente.trim() == "133594"){
        PilotosFunctions.ponerCia(this,"EMPRESA MONFORTE");
      }
      this.checkCampa();
    }
  }

  //se llama por el usuario al filtrar por los campos de arrays de objectos
  private _filterObject(value: string|null, optionArr: any[], propiedades: string[]): any[] {
    if (value != null) {
      const filterValue = value.toString().toLowerCase();
      // Filtrar basado en múltiples propiedades
      return optionArr.filter(option =>
          propiedades.some(propiedad =>
              option[propiedad] && option[propiedad].toString().toLowerCase().includes(filterValue)
          )
      );
    } else {
      return optionArr;
    }
  }

  private checkMutuaVerification(): void {

    if (this.cambioCompaniaAutomatica) {
      console.log("Verificación Mutua ignorada (cambio automático desde Mutua).");
      this.cambioCompaniaAutomatica = false;
      return;
    }

    const entrada = (this.llamada?.entrada || "").toString().trim();
    const cia = (this.ciaSeleccionada?.cliente || "").toString().trim();

    const pilotosMutua = ['10000022', '100000096', '100000112'];
    const ciasMutua = ['128968', '135486'];

    const pilotoOk = pilotosMutua.some(p => entrada.includes(p));
    const ciaOk = ciasMutua.includes(cia);
    this.llamada.observ = "";

    if ((pilotoOk || ciaOk) && this.tallerSeleccionado) {
      
      if (!this.previousTallerSeleccionado?.delegacion || this.previousTallerSeleccionado.delegacion.toString().trim() === "") {
        console.warn("previousTallerSeleccionado vacío o null. Cortando ejecución.");
        return;
      }

      const tallerCodigo = this.tallerSeleccionado.delegacion.toString();

      // verificar permiso antes de abrir el modal
      this.mutuaService.verificarPermisoMutuaHub(tallerCodigo).subscribe({
        next: (res) => {
          if (res?.permiso === true) {
            
            console.log(`Taller ${tallerCodigo} tiene permiso Mutua`);

            //abrir modal solo si tiene permiso
            const dialogRef = this.dialog.open(VerificacionMutuaDialogComponent, {
              width: '60%',
              disableClose: false,
              data: {
                token: this.token,
                taller: tallerCodigo,
                matricula: this.vehiculo.matricula || '',
                fecha: this.asegurado.fecSin || new Date().toISOString().slice(0, 10),
                formularioHojas: this,
              }
            });

            dialogRef.afterClosed().subscribe(res => {
              if (!res) {
                console.warn("Usuario cerró el modal sin guardar.");
                return;
              }

              const payload = Array.isArray(res) ? res[0] : res;
              console.log("Datos recibidos al cerrar (normalizados):", payload);

              this.asegurado.poliza = payload?.poliza?.idPoliza || this.asegurado.poliza;

              if (payload?.vehiculo) {
                this.vehiculo.marca = (payload.vehiculo.marca || this.vehiculo.marca)?.trim();
                this.vehiculo.modelo = (payload.vehiculo.modelo || this.vehiculo.modelo)?.trim();
                this.vehiculo.matricula = (payload.vehiculo.matricula || this.vehiculo.matricula)?.trim();
              }

              const siniestro = payload?.siniestros?.[0];
              if (siniestro) {
                this.asegurado.siniestro = siniestro.siniestro?.toString() || this.asegurado.siniestro;
                this.vehiculo.descSiniestro = siniestro.descripcionTipoSiniestro || this.vehiculo.descSiniestro;
                this.asegurado.fecSin = siniestro.fechaAccidente;
                this.mensajeObser = (this.mensajeObser || '') + `\nDescripción siniestro MUTUA: ${siniestro.danios || ''}`;
              }

              if (payload?.tiposSiniestroPiezas && payload.tiposSiniestroPiezas.length > 0) {
                this.llamada.observ = (this.llamada.observ || '') + `\nValidación OK – Con cobertura de lunas`;
                this.mensajeObser = (this.mensajeObser || '') + '\n' + this.llamada.observ;
              } else {
                const alertRef = this.dialog.open(AlertArgumentarioComponent, {
                  data: {
                    titulo: "¿Cambiar compañía?",
                    lineas: ["¿Desea cambiar la compañía a CONTADO?"],
                    mostrarBtnAceptar: true,
                    mostrarBtnCancelar: true
                  },
                  disableClose: true
                });
                alertRef.afterClosed().subscribe((cambia: boolean) => {
                  if (cambia) {
                    this.auxCia = "009999";
                    this.flagSinCoberturaMutua = true;
                    this.changeCia();
                    this.llamada.observ = (this.llamada.observ || '') + `\nSin cobertura de lunas, cambio a contado`;
                    this.mensajeObser = (this.mensajeObser || '') + '\n' + this.llamada.observ;
                  } else {
                    this.llamada.observ = (this.llamada.observ || '') + `\nSin cobertura de lunas`;
                    this.mensajeObser = (this.mensajeObser || '') + '\n' + this.llamada.observ;
                  }
                });
              }
            });
          } else {
            console.warn(`Taller ${tallerCodigo} NO tiene permiso Mutua`);
          }
        },
        error: (err) => {
          console.error("Error verificando permiso Mutua:", err);
        }
      });
    }
  }

  //agrega las escuchas de los filtros
  private _agregarEscuchas():void
  {
    this.talleresDisponiblesF = this.talleresDisponiblesControl.valueChanges.pipe
    (
        startWith(""),
        map(value=>this._filterObject(value,this.talleresDisponibles,["nombre", "delegacion"]))
    );

    this.ciasDisponiblesF = this.ciasDisponiblesControl.valueChanges.pipe
    (
        startWith(""),
        map(value=>this._filterObject(value,this.cias,["nombre", "cliente"]))
    );
  }

  async guardarHoja()
  {
    //Deshabilitamos el boton de guardar para evitar multiples clicks
    this.disableBtnGuardar = true;


    //Revisamos si se han guradado los daños en Prisma
    if (this.tallerBooking && (!this.caseID || !this.caseID.trim())) {
      this.mostrarArgumentario("Atención!", ["Debes guardar los daños en Prisma antes de guardar la hoja."], false, true, true);
      this.disableBtnGuardar = false;
      return;
    }


    // BLOQUEO extra: en booking exige caseId (Prisma) antes de guardar
    if (this.tallerBooking && (!this.caseID || !this.caseID.trim()) &&
        !this.trabajosOmisionCita.includes(this.trabajoSeleccionado)) {
      this.mostrarArgumentario("Atención!", ["Debes guardar los daños en Prisma antes de guardar la hoja."], false, true, true);
      return;
    }


    //Cuando no tiene cobertura por parte de mutua y el cliente en este caso es diferente a contado, no dejamos guardar la hoja.
    if (
    this.flagSinCoberturaMutua &&
    (this.ciaSeleccionada?.cliente || '').toString().trim() !== '009999'
    ) {
      this.mostrarArgumentario(
        "Atención!",
        ["No puedes guardar la Hoja ya que el siniestro no tiene cobertura y tiene que ser cliente contado."],
        false,
        true,
        true
      );
      return;
    }
    //En esta parte vamos a revisar en este caso que antes de guardar la HOJA, tengamos contemplado los siguientes d
      const citaObligatoria = (!this.trabajosOmisionCita.includes(this.trabajoSeleccionado)) || (this.trabajosOmisionCita.includes(this.trabajoSeleccionado) && this.clienteCita.includes(this.ciaSeleccionada!.cliente.toString().trim()));
    if(this.tallerBooking && this.fechaCitaBooking == "" && this.horaCitaBooking == "" 
      && citaObligatoria)
    {
      this.mostrarArgumentario("Atención!", ["¡Es obligatorio agendar cita!."], false, true, true);
      this.disableBtnGuardar = false;
      return;
    } 
    else//Revisamos que los campos obligatorios esten rellenos
    if (    
      this.tallerSeleccionado && 
      this.ciaSeleccionada && 
      this.vehiculo.matricula.trim() != "" &&
      this.llamada.entrada != "" && 
      this.llamada.origen != "" && 
      this.llamada.tipo != ""
      &&
      (
        this.vehiculo.descSiniestro != "" || 
        (this.trabajoSeleccionado != "" && this.vehiculo.descSiniestro == "")
      )
      &&
      (
        !this.clientesMutua.includes((this.ciaSeleccionada?.cliente || '').toString().trim()) 
        || this.asegurado.fecSin
      )
      &&
      (
        (this.emailFacilitado == 'si' && this.asegurado.email != "") || 
        this.emailFacilitado == 'no_tiene' || 
        this.emailFacilitado == 'no_proporcionado'
      )
    ) 
    {
      //Obtenemos el token de acceso
      await this.getAccessTokenPromise();
      let correcto = await this.checkCondicionGuardar();
      if(correcto)
      {
        let hojaRellenada:Hoja = GestionHoja.rellenarDatosNew(this);
        
        if(hojaRellenada)
        {
          const dialogRef = this.dialog.open(AlertArgumentarioComponent,
          {
            data: {titulo: "Guardando hoja",lineas:[],mostrarBtnCierre:false},
            disableClose:true
          });
              
          dialogRef.afterClosed().subscribe(result => {});
          this.stopIntervalGetArticulo();

          this.hojaService.guardarHoja(this.token, hojaRellenada)
              .then
              (
                  res=>
                  {
                    if (!res || res.success !== true) {
                      dialogRef.close();
                      const errores: string[] = [];
                      if (res && res.message) {
                        errores.push(res.message);
                      } else {
                        errores.push("Respuesta inesperada del servidor");
                      }
                      this.mostrarArgumentario("Error al guardar hoja:", errores, false, true, true);
                      this.disableBtnGuardar = false;
                      return;
                    }

                    this.hojaGuardada = res.hoja ? res.hoja.toString() : "";

                    dialogRef.close();

                    const dialogRes = this.dialog.open(AlertArgumentarioComponent,
                        {
                          data: {titulo: "Hoja guardada:",lineas:[res.message, this.hojaGuardada ? "Nº hoja: " + this.hojaGuardada : ""].filter(x=>x!=""), mostrarBtnCierre:true},
                          disableClose:false,
                        });

                    dialogRes.afterClosed()
                        .subscribe(result => {
                                this.enviarEmailsHoja();
                          });
                  }
              )
              .catch(err=>
              {
                dialogRef.close();

                var errores: string[] = []
                if (err && err.error && err.error.message) {
                  errores.push(err.error.message);
                  if (err.error.detail) {
                    errores.push(err.error.detail);
                  }
                } else if (err && err.message) {
                  errores.push(err.message);
                } else {
                  errores.push("Error al guardar la hoja");
                }
                this.mostrarArgumentario("Error al guardar hoja:",errores, false, true, true);
                this.disableBtnGuardar = false;
              });
        }
      }
    } 
    // No estan rellanados los casos, mostramos mensaje de error
    else {
      
      const clienteActual = (this.ciaSeleccionada?.cliente || '').toString().trim();
      const esMutua = this.clientesMutua.includes(clienteActual);

      const mensajes = [
        "Se debe de elegir un taller y una compañia antes.",
        "Se debe de informar la matrícula.",
        "Se debe de seleccionar un piloto, origen y tipo de llamada.",
        "Se debe de informar un email si se indica que dispone",
        "Se debe de indicar una descripción del siniestro o trabajo a realizar"
      ];
      
      // Solo añadiremos este mensaje si es cliente mutua.
      if (esMutua && (!this.asegurado.fecSin || !this.asegurado.fecSin.trim())) {
        mensajes.push("Para clientes Mutua, también es obligatoria la fecha del siniestro");
      }

      const detalle = this.getInfoSiniestroFormateada();
      if (!detalle) {
        mensajes.push("Para clientes Mutua, es obligatorio indicar lugar y cómo ocurrió el siniestro");
      }

      this.mostrarArgumentario(
        "Faltan campos por rellenar",
        mensajes,
        false, true, true
      );

      this.disableBtnGuardar = false;
      return;
      
    } 
  }

  async checkCondicionGuardar(): Promise<boolean> {
    let tipo: string = "";
    let resultado: boolean = false;

    try {
      const res = await this.clienteService.getTipoCliente(
          this.token,
          this.tallerSeleccionado!.delegacion.toString(),
          this.ciaSeleccionada!.cliente.toString().trim()
      );
        console.table(res);
      if (res.length > 0) {
        tipo = res[0].tipo.toString().trim();
        let piloto = this.llamada.entrada;
        let numcli = this.ciaSeleccionada!.cliente.toString().trim();

        if (tipo != "PROM" && piloto != "100000024" && !["116048", "130529", "132697", "136641", "009999", "128331"].includes(numcli) && (this.artsSeleccionadosSource.data.length == 0 && !this.tallerBooking)) {
          this.mostrarArgumentario("Atención!", ["Es obligatorio seleccionar un artículo para Grabar la Hoja en el Cliente seleccionado"], false, true, true);
        } else {
          if (this.llamada.origen != "") {
            if (piloto == "100000024" && (this.artsSeleccionadosSource.data.length == 0 && !this.tallerBooking) && this.trabajoSeleccionado == "") {
              this.showTrabajos = true;
              this.mostrarArgumentario("Atención!", ["En el piloto seleccionado sin artículos, es obligatorio indicar trabajos a realizar"], false, true, true);
            } else {
              if (numcli == "120205") {
                if ((this.asegurado.dni != "" || this.asegurado.poliza != "") && this.asegurado.nombre != "" && Number(this.asegurado.tel1) && this.asegurado.tel1.length == 9) {
                  resultado = true;
                } else {
                  this.mostrarArgumentario("Atención!", ["DNI o Poliza y teléfono obligatorios.", "Revisar datos del cliente para poder abrir el siniestro."], false, true, true);
                }
              } else {
                if (numcli == "130540" || numcli == "130129") {
                  resultado = true;
                } else {
                  if (numcli == "121668" && this.entidadSeleccionada == "") {
                    this.mostrarArgumentario("Atención!", ["En Asitur la Entidad es Obligatoria."], false, true, true);
                  } else {
                    if (numcli == "140334" && this.asegurado.email == "") {
                      this.mostrarArgumentario("Atención!", ["En Axa Seg.Gen.Campaña Ozono el email es obligatorio."], false, true, true);
                    } else {
                      if (this.asegurado.dni != "" && this.asegurado.nombre != "" && Number(this.asegurado.tel1) && this.asegurado.tel1.length == 9 && this.vehiculo.matricula != "" && this.vehiculo.marca != "" && this.vehiculo.modelo != "") {
                        resultado = true;
                      } else {
                        this.mostrarArgumentario("Atención!", ["Revise Marca, Modelo, Nombre, DNI, Matricula, Teléfono cliente (9 Dígitos)."], false, true, true);
                      }
                    }
                  }
                }
              }
            }
          } else {
            this.mostrarArgumentario("Atención!", ["Es obligatorio informar quién le ha recomendado el taller."], false, true, true);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching client type:", error);
      throw error; // or handle this error appropriately
    }

    return resultado;
  }


  enviarEmailsHoja(){
    if (this.idcorredor != "") {
        // Se rellenan los emails der RLS
        this.rls.getEmailCom(this.token, this.asegurado.agente, this.tallerSeleccionado!.delegacion).then(
            res => {
            for (let i = 0; i < res.length; i++) { 
                
                this.respEmail.push(res[i].emailcial1?.toString());
                this.respEmail.push(res[i].emailzona1?.toString());
                this.respEmail.push(res[i].emailcial2?.toString());
                this.respEmail.push(res[i].emailzona2?.toString());
            }
            this.respEmail = Array.from(new Set(this.respEmail.filter(element => element !== null && element !== undefined && element !== '')));
            }
        )
    }
    // Logica para talleres booking
    if(this.fechaCitaBooking == "" && this.horaCitaBooking == ""){
        this.enviarEmail("noCita");
    }else{
        this.enviarEmail("cita");
    }
  }

  enviarEmail(tipo: string){
    let arrParam = {
      "parameters":
        [
          [
            {
              campo: "ad.delegacion",
              operacion: "=",
              valor: this.tallerSeleccionado!.delegacion
            }
          ]
        ],
      select: ["ad.email as email"]
    };
    this.delegacionService.getDelegacionesCustom(this.token, arrParam).then(res => {
      if (res.length > 0) {
        let email = res[0].email.toString().trim();
        let cliente = this.asegurado.nombre + " " + this.asegurado.tel1;
        let obser = "";
        let obserAdas = "";
        let mensaje = "";
        let bcc = [];
        if (this.peticionRealizada == "SI") {
          obser = "REVISAR LA PETICIÓN YA REALIZADA";
        } else {
          obser = "PETICIÓN NO REALIZADA";
        }

        if (this.selectAdas == "SI") {
          obserAdas = "Audatex informa que el vehículo dispone de ADAS y se debe de Calibrar.";
        }

        if (this.asegurado.servicio == "um") {
          if (this.idcorredor != "") {
            mensaje = "Hoja de trabajo CallCenter con RLS y UNIDAD MOVIL. Hoja " + this.hojaGuardada + " del taller " + this.tallerSeleccionado!.delegacion + " con matrícula " + this.vehiculo.matricula;
          } else {
            mensaje = "Hoja de trabajo CallCenter con UNIDAD MOVIL. Hoja " + this.hojaGuardada + " del taller " + this.tallerSeleccionado!.delegacion + " con matrícula " + this.vehiculo.matricula;
          }
        } else {
          if (this.idcorredor != "") {
            mensaje = "Hoja de trabajo CallCenter con RLS. Hoja " + this.hojaGuardada + " del taller " + this.tallerSeleccionado!.delegacion + " con matrícula " + this.vehiculo.matricula;
          } else {
            mensaje = "Hoja de trabajo CallCenter. Hoja " + this.hojaGuardada + " del taller " + this.tallerSeleccionado!.delegacion + " con matrícula " + this.vehiculo.matricula;
          }
        }

        let cuerpo = "";
        if (tipo == "noCita") {
          bcc.push("marketing@ralarsa.com")
          if (this.idcorredor != "") {
            cuerpo = `Se ha abierto la Hoja ${this.hojaGuardada} con RLS en el taller ${this.tallerSeleccionado!.delegacion} desde la central por ${this.usuario.toUpperCase()} \n ${obser} \n ${obserAdas} \n LLAMAR AL CLIENTE URGENTE. \n ${cliente} \n ${this.mensajeObser} \n Matrícula: ${this.vehiculo.matricula}`;
          } else {
            cuerpo = `Se ha abierto la Hoja ${this.hojaGuardada} en el taller ${this.tallerSeleccionado!.delegacion} desde la central por ${this.usuario.toUpperCase()}. \n ${obser} \n ${obserAdas} \n LLAMAR AL CLIENTE URGENTE. \n ${cliente} \n ${this.mensajeObser} \n Matrícula: ${this.vehiculo.matricula}`;
          }
        } else {
          if (this.idcorredor != "") {
            cuerpo = `Se ha abierto la Hoja ${this.hojaGuardada} con RLS en el taller ${this.tallerSeleccionado!.delegacion} desde la central por ${this.usuario.toUpperCase()}. \n Grabada en la Agenda el dia ${this.convertirFecha(this.fechaCitaBooking)} a las ${this.horaCitaBooking}. \n ${obser} \n ${obserAdas} \n LLAMAR AL CLIENTE URGENTE. \n ${cliente} \n ${this.mensajeObser} \n Matrícula: ${this.vehiculo.matricula}`;
          } else {
            cuerpo = `Se ha abierto la Hoja ${this.hojaGuardada} en el taller ${this.tallerSeleccionado!.delegacion} desde la central por ${this.usuario.toUpperCase()}. \n Grabada en la Agenda el dia ${this.convertirFecha(this.fechaCitaBooking)} a las ${this.horaCitaBooking}. \n ${obser}  \n ${obserAdas} \n LLAMAR AL CLIENTE URGENTE. \n ${cliente} \n ${this.mensajeObser} \n Matrícula: ${this.vehiculo.matricula}`;
          }
        }

        var arrParams = {
          "sender": "callcenter@ralarsa.com",
          "to": [email],
          "cc": this.respEmail,
          "bcc": bcc,
          "subject": mensaje,
          "body": cuerpo
        }

        this.emailService.enviarEmail(this.token, arrParams).then(res => {
          if (res == "OK") {
            if (tipo == "cita"){
              this.enviarCitaCliente().then(res => {
                this.mostrarArgumentarioRes("Guardado", ["Email enviado correctamente"]).subscribe(() => {
                  location.reload();
                });
              });
            }else{
              this.mostrarArgumentarioRes("Guardado", ["Email enviado correctamente"]).subscribe(() => {
                location.reload();
              });
            }
          } else {
            this.mostrarArgumentarioRes("Error", ["Ha habido un error al enviar el email."], false, true, true).subscribe(() => {
              location.reload();
            });
          }
        })

      } else {
        this.mostrarArgumentarioRes("Error", ["Esta delegación no dispone de ningún email de contacto, no se enviara el email"]).subscribe(() => {
          location.reload();
        });
      }
    });
  }

  async enviarCitaCliente() {
    if (this.asegurado.servicio != "um") {
      if (!this.tallerBooking) {
        if (this.ciaSeleccionada!.par_012 == 'S' && this.asegurado.tel1 && this.asegurado.tel1 != "") {
          await this.enviarSMSCita();
        }
        if (this.ciaSeleccionada!.par_015 == 'S' && this.asegurado.email != "" && this.emailFacilitado == "si") {
          await this.enviarEmailCita();
        }
      } else if ((this.asegurado.email != "" && this.emailFacilitado == "si")) {
        await this.enviarEmailCita();
      } else if (this.asegurado.tel1 && this.asegurado.tel1 != "") {
        await this.enviarSMSCita();
      }
    }
  }

  async enviarEmailCita(){
    var arrParams = {
      "delegacio": this.tallerSeleccionado!.delegacion,
      "num_alb": this.hojaGuardada,
      "email_cliente": this.asegurado.email,
    }
    this.emailService.enviarEmailHTML(this.token, arrParams).then(res => {
      if(res == "OK"){
        return res;
      }else{
        return "Error SMS";
      }
    });
  }

  async enviarSMSCita(){
    let servicio = "SI";
    if(this.asegurado.servicio == "taller"){
      servicio = "NO";
    }
    var arrParams = {
      "delegacio": Number(this.tallerSeleccionado!.delegacion),
      "num_alb": Number(this.hojaGuardada),
      "telefono_cliente": this.asegurado.tel1.toString(),
      "fecha": this.convertirFecha(this.fechaCitaBooking),
      "hora": this.horaCitaBooking.toString(),
      "cpo": "0",
      "cliente": Number(this.ciaSeleccionada!.cliente.toString().trim()),
      "nom": this.ciaSeleccionada!.nombre.toString().trim(),
      "um": servicio,
      "matricula": this.vehiculo.matricula.toString()
    }
    this.emailService.enviarSMS(this.token, arrParams).then(res => {
      if(res == "OK"){
        return res;
      }else{
        return "Error SMS";
      }
    });
  }

  convertirFecha(fecha: string): string {
    //const [year, month, day] = fecha.split('-').map(part => parseInt(part, 10).toString());
    const [year, month, day] = fecha.split('-').map(part => part.padStart(2, '0'));
    return `${day}-${month}-${year}`;
  }

  obtenerSiniestro(){
    this.showObtenerSiniestro = false;
    this.hojaService.siniestroHoja(this.token)
        .then(res => {
          this.asegurado.siniestro = res;
        })
  }

  datosSiebel(){
    this.mensajeObser += "LEASE PLAN AMAZON ";
    this.mostrarArgumentario("Atención" ,["Abre en el VB el programa de LeasePlan."]);
  }
  openPelayo(){
    this.mostrarArgumentario("Atención" ,["Abre en el VB el programa de WebPelayo."]);
  }
  openMapfre(){
    this.mostrarArgumentario("Atención" ,["Abre en el VB el programa de WebMapfre."]);
  }
  abrirMussap(){
    window.open('https://www.mussap.net/ca/web/public/tallers', '_blank');
  }
  abrirAxa(){
    window.open('https://www.axa.es/servicios/centro-siniestros-buscador-talleres', '_blank');
  }

  abrirGlassTalleres(): void {
    this.dialog.open(GlassTalleresComponent, {
      data: { formularioHojas: this },
      width: '900px',
      maxWidth: '95vw',
      maxHeight: '90vh',
    });
  }

  abrirAllianz(){
    window.open('https://www.allianz.es/centro-respuesta-rapida/utilidades/talleres/talleres-lunas.html', '_blank');
  }
  mostrarDatosCia()
  {
    if(this.tallerSeleccionado!=null && this.ciaSeleccionada!=null)
    {
      let match = this.ciaSeleccionada?.nombre.match(/0\d/);
      let datosCia : string[] =[];
      this.clienteService.getObservacionesCia(this.token,this.tallerSeleccionado.delegacion,this.ciaSeleccionada.cliente)
          .then(res=>
          {
            datosCia=res
          })
          .finally(()=>
          {
            this.mostrarArgumentario(this.ciaSeleccionada?.cliente! +" "+this.ciaSeleccionada?.nombre ,datosCia);
          })
    }
  }

  cargarComboCias(delegacion:string,ciaPrevia?:string)
  {
    this.cias = [];
    if(this.tallerSeleccionado)
    {
      this.clienteService.getValoresClientes(this.token,delegacion).then(
          res=>
          {
            this.cias = res;
          }
      ).finally( () =>
          this.changeCia())
    }
  }

  //recoge los datos de el taller seleccionado
  getDatosTaller(): Promise<AnexoDelegacion>
  {
    return new Promise<AnexoDelegacion>((resolve, reject) =>
    {
      let datos: AnexoDelegacion;

      if (this.tallerSeleccionado != null && this.tallerSeleccionado.delegacion)
      {
        this.delegacionService.getDatosDelegacion(this.token, this.tallerSeleccionado.delegacion)
            .then(
                res =>
                {
                  datos = res;
                  resolve(datos);
                })
            .catch(err => {reject(err);});
      }
    });
  }
  cargarTallerMapfre(){
    this.delegacionService.getDelegacionesMafre(this.token)
        .then(res=>
        {
          this.talleresDisponibles = res
        });
  }
  

  //Funcion para mostrar el valor de cliete y nombre de la cia tras seleccionarla en el selector
  displayCiaCombo(option:any):string{return option ? option.nombre.trim()+" "+option.cliente.trim():""}
  displayDelegacionCombo(option:any):string{return option ? option.delegacion+" "+option.nombre.trim():""}

  //busca el DNI en la tabla de persones
  buscarDni(dni:string):void
  {
    if(this.asegurado.dni){
      this.ocultarBuscaCliente = false;
      dni=dni.trim();
      let tempAsegurados : Persona[] = [];
      if(dni.length==8 && !/^[A-Za-z]/.test(dni[0]))
      {
        dni += calculateDNILetter(Number.parseInt(dni));
        this.asegurado.dni=dni;
      }
      this.personaService.getDatosDni(this.token,dni)
          .then
          (res=>
          {
            this.ocultarBuscaCliente = true;
            tempAsegurados = res;
          })
          .finally(()=>
          {
            switch (tempAsegurados.length)
            {
              case 0:
                this.mostrarArgumentario("No encontrado",["No se han encontrado asegurados con el NIF/DNI proporcianado."]);
                break;
              case 1:
                //ASIGNAR LOS VALORES DEL único resultado
                this.asegurado.dni=tempAsegurados[0].nif.toString().trim();
                this.asegurado.dirCliente=tempAsegurados[0].direcc.toString().trim()
                this.asegurado.nombre=tempAsegurados[0].nom.toString().trim();
                this.asegurado.tel1=tempAsegurados[0].telef.toString().trim();
                if(tempAsegurados[0].email.trim()!="")
                {
                  this.asegurado.email=tempAsegurados[0].email.toString().trim();
                  this.emailFacilitado="si";
                }
                else {this.emailFacilitado="no_tiene";}
                break;
              default:
                //GUARDAR TODOS LOS RESULTADOS en un array para cargarlo en los options
                tempAsegurados.forEach(a =>
                {
                  a.nom = a.nom.trim();
                  a.direcc = a.direcc.trim();
                  a.nif = a.nif.trim();
                  a.telef = a.telef.trim();
                });
                break;
            }
          });
    }

  }




  
  //carga los talleres del combobox
  cargarListadoTalleres(piloto: string, tallerSeleccionar: string = "")
  {
    let anexo = new AnexoDelegacion(this.delegacionService, this.msalService, null, "007", "RALARSA HOLDING");
    this.tablas.getTalleresExcluidos(piloto, this.token).then(
        res =>{
          if (res != ""){
            let aux = res[0].dades.trim().split(",");
            this.delegacionService.getDelegacionesExclude(this.token, aux)
                .then(res=>
                {
                  res.push(anexo);
                  this.talleresDisponibles = res;

                  if (tallerSeleccionar != ""){
                    this.changeTaller(tallerSeleccionar);
                  }
                });
          }else{
            this.delegacionService.getDelegaciones(this.token)
                .then(res=>
                {
                  res.push(anexo);
                  this.talleresDisponibles = res;

                  if (tallerSeleccionar != ""){
                    this.changeTaller(tallerSeleccionar);
                  }
                });
          }
        }
    )

  }

  recargarTipo(piloto: string){
    let array = {
      "parameters":
          [
            [
              {
                campo: "prefix",
                operacion: "=",
                valor: "TO"
              }
            ],
            [
              {
                campo: "codi",
                operacion: "<>",
                valor: '9'
              }
            ]
          ],
      select: ["codi", "descripcio"],
      orden: [["codi", "asc"]]
    };
    let operacion = "<="
    if (piloto == "200000100"){
      operacion = ">"
    }
    array.parameters.push([
      {
        campo: "codi",
        operacion: operacion,
        valor: '200'
      }
    ])
    this.tablas.personalizarTablas(array, this.token).then(
        res => {
          this.tipoLlamadaList = res;
        }
    )
  }
  cargarAvisosTaller(): void
  {
    if (this.tallerSeleccionado)
    {
      this.mensajeAvisoTalles = ""
      let mensaje: string[] = []
      this.delegacionService.getAvisoTaller(this.token,this.tallerSeleccionado.delegacion).then(res => {
        if (Array.isArray(res) && res.length) {

          res.forEach((elemento) => {
            if(elemento.text.trim() != ""){
              this.mensajeAvisoTalles += `${elemento.num} ${elemento.text.trim()}\n`;
              mensaje.push(`${elemento.num} ${elemento.text.trim()}`)
            }
          });
        }

        if(this.mensajeAvisoTalles){
          this.mostrarArgumentario("Atención",mensaje);
        }
      });
    }
  }
  //muestra en el argumentario los datos del taller
  mostrarDatosTaller():void
  {
    let datos :AnexoDelegacion;
    let detallesTaller : string [] = [];

    this.getDatosTaller()!.
    then(res=>
    {
      datos=res;
      detallesTaller =
          [
            "Dirección: " + (datos.direccion ?? '-'),
            "Población: " + (datos.poblacion ?? '-'),
            "Código postal: "+(datos.cp ?? '-'),
            "Teléfono: "+(datos.telefono.toString().replaceAll(".", "") ?? '-'),
            (datos.telefono2 ? 'Teléfono 2 : '+datos.telefono2.toString().replaceAll(".", ""):''),
            "",
            //"Horario:",
            "Horario de mañana: "+  (datos.horario_apertura_mañanas ?? '')+ " - "+(datos.horario_cierre_mañanas ?? ''),
            "Horario de tarde: "+   (datos.horario_apertura_tardes ?? '')+ " - "+(datos.horario_cierre_tardes ?? ''),
            (datos.horario_apertura_sabados.toUpperCase().includes("CERRADO") ? "Horario de sábado: CERRADO" : "Horario de sábado: "+  (datos.horario_apertura_sabados ?? '')+ " - "+(datos.horario_cierre_sabados ?? '')),
          ];
    }).
    finally(()=>
    {
      if(datos!=null)
      {this.mostrarArgumentario("Datos "+datos.delegacion+" "+datos.nombre ,detallesTaller);}
    });
  }

  private rollbackTaller: boolean = false;

//verifica si es un taller diferenet al anterior
   onTallerSeleccionadoChange(newValue: any)
  {
    this.ResetCaseID();

    if (this.firstEntry){
      this.firstEntry = false;
    }else{
      if (newValue !== this.previousTallerSeleccionado && newValue!="")
      {
        this.previousTallerSeleccionado = newValue;
        if(this.previousTallerSeleccionado.delegacion)
        {
          if(this.ciaSeleccionada)          {
            this.cargarComboCias(this.tallerSeleccionado!.delegacion + "", this.ciaSeleccionada.nombre);
          }
          else
          {
            this.cargarComboCias(this.tallerSeleccionado!.delegacion + "");            
          }
          this.cargarAvisosTaller();
          if (this.tallerSeleccionado?.delegacion == "392" || this.tallerSeleccionado?.delegacion == "393"){
            this.vehiculo.descSiniestro = "05";
          }
        }
        this.checkCampa();
        this.tallerBooking = this.tallerSeleccionado!.booking;
      }
    }
  }
  onTallerOCiaSeleccionadoBlur() {
    if (this.firstEntry) {
      this.firstEntry = false;
    } else {
      this.checkDeudaCliente();
    }
  }
  checkDeudaCliente() { 
      const taller = this.tallerSeleccionado?.delegacion?.toString();
      const cia = this.ciaSeleccionada?.cliente?.toString();

      if (taller && cia) {
        this.clienteService.getTieneDeuda(this.token, taller, cia.trim()).then(
          res => {
            if (res === true) {
              this.mostrarArgumentario(
                "Atención, CLIENTE CON DEUDA PENDIENTE",
                ["No es posible agendar el servicio. El cliente debe contactar a su centro habitual para regularizar su deuda antes de continuar."],
                false, true, true
              );
              // Limpiamos la cia seleccionada
              this.ciaSeleccionada = null;
              this.previousCiaSeleccionada = null;
            }
          }
        );
      }
  }
  onCiaSeleccionadoChange(newValue: any){

    if (newValue != null){
      if (newValue !== this.previousCiaSeleccionada && newValue!="") {
        
        //Verificamos en este caso los pilotos de mutua y tambien la cia y asi poder mostrar el popup.
        this.checkMutuaVerification();
        
        //Funcionalidad previa
        this.showEntidad = false;
        this.prefixEntidad = "";
        this.showMapfre = false;
        this.previousCiaSeleccionada = newValue;
        if (this.previousCiaSeleccionada.cliente){
          if (this.diccionarioEntidadFunciones.hasOwnProperty(this.previousCiaSeleccionada.cliente.toString().trim())) {
            this.diccionarioEntidadFunciones[this.previousCiaSeleccionada.cliente.toString().trim()]();
          }else{
            this.diccionarioEntidadFunciones["else"]();
          }

          if(this.asegurado.agente == ""){
            let array = {
              "parameters":
                  [
                    [
                      {
                        campo: "prefix",
                        operacion: "=",
                        valor: "SA"
                      }
                    ],
                    [
                      {
                        campo: "codi",
                        operacion: "LIKE",
                        valor: this.previousCiaSeleccionada.cliente.toString().trim() + "%"
                      }
                    ]
                  ],
              select: ["dades"]
            };
            this.tablas.personalizarTablas(array,this.token).then(res => {
              if (res.length > 0){
                this.asegurado.agente= res[0].dades.toString().trim();
              }
            })
          }
        }
        this.checkCampa();
      }
    }

  }


  onEntidadChange(newValue: any){
    if (newValue != null){
      this.checkCampa();
    }
  }

  onDescSiniestroChange(): void {

    const clienteActual = (this.ciaSeleccionada?.cliente || '').toString().trim();
    const esMutua = this.clientesMutua.includes(clienteActual);

    if (!esMutua) return;

    if (!this.tallerSeleccionado?.delegacion) {
      console.warn("No hay taller seleccionado");
      return;
    }

    const tallerCodigo = this.tallerSeleccionado.delegacion.toString();

    this.mutuaService.verificarPermisoMutuaHub(tallerCodigo).subscribe({
      next: (res) => {

        if (res?.permiso !== true) {
          console.warn(`Taller ${tallerCodigo} sin permiso Mutua`);
          return;
        }

        // SOLO si tiene permiso, abrimos el popup
        const dialogRef = this.dialog.open(SiniestroExtraDialogComponent, {
          width: '50%',
          minWidth: '400px',
          maxWidth: '700px',
          data: {
            lugar: this.infoSiniestroExtra.lugar,
            como: this.infoSiniestroExtra.como,
            formularioHojas: this
          }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
          if (result) {
            this.infoSiniestroExtra.lugar = result.lugar || '';
            this.infoSiniestroExtra.como = result.como || '';
          }
        });
      },
      error: (err) => {
        console.error("Error verificando permiso Mutua:", err);
      }
    });
  }

  private changeTaller(buscar: string){
    this.ResetCaseID();
    const dato = this.talleresDisponibles.find(t=>
        t.delegacion.toString().trim().includes(buscar.trim()) || t.nombre.toUpperCase().trim().includes(buscar.toUpperCase().trim())
    );
    if (dato != null){
      this.tallerSeleccionado = dato;
    }
  }


  private changeCia() {
  if (this.auxCia != '') {
    
    const dato = this.cias
      .sort((a, b) => parseInt(a.cliente) - parseInt(b.cliente))
      .find(t =>
        t.nombre.toUpperCase().trim().includes(this.auxCia.toUpperCase().trim()) ||
        t.cliente.toUpperCase().trim().includes(this.auxCia.toUpperCase().trim())
      );

    if (dato != null) {
     
      this.ciaSeleccionada = dato;
      this.onCiaSeleccionadoChange(dato);
    }
  }
}



  //carga las marcas disponibles de coches en el selector de marcas
  private cargarMarcas():void
  {
    this.articuloService.getMarcas(this.token)
        .then(res=>
        {
          if (res.length > 0){
            res.forEach
            (marca =>
            {
              this.marcasDisponibles.push(marca.marca);
            });
          }else{
            this.marcasDisponibles.push("");
            this.mostrarArgumentario("Atención", ["No se han encontrado marcas registradas en la base de datos."], true, true, true);
          }

        }).catch(()=>
    {
      this.marcasDisponibles=["No disponible"];
    });
  }

  //Muestra el form de taller preferente
  mostrarTallerPreferente():void
  {
    if(this.llamada.entrada != ""){
      if(this.direccion != "" && this.kmDireccion != null)
      {
        if (this.asegurado.servicio == 'um' && !isNaN(parseInt(this.direccion))){
          //probar a llamar cp
          this.cp.getTalleresCp(this.token, this.direccion).then(res => {
            if(res.length > 0){
              this.changeTaller(res[0]["tall1"].toString());
            }else{
              this.buscarTallerPreferenteDialog();
            }
          });
        }else{
          this.buscarTallerPreferenteDialog();
        }

      }else{
        this.mostrarArgumentario("AVISO",
          ["Debes de rellenar la dirección e indicar los KM para buscar."], false, true, true);
      }
    }else{
      this.mostrarArgumentario("AVISO",
        ["Debes de indicar la entrada de la llamada para proceder a la busqueda."], false, true, true);
    }
  }

  buscarTallerPreferenteDialog(){
    const dialogRef = this.dialog.open(BuscadorTallerComponent,
      {
        data:
          {
            direccionBusqueda: this.direccion,
            km: this.kmDireccion,
            unidadMovil: this.asegurado.servicio,
            token: this.token
          }
      }
    );

    dialogRef.afterClosed()
      .subscribe(result =>
      {
        //SI el result es valido
        if(result != undefined && result != null && result != "")
        {
          if (result == "pato"){
            this.mostrarArgumentario("AVISO",
              ["NO hay talleres cercanos con los criterios de busqueda seleccionados"], false, true, true);
          }else{
            //asignamos el taller seleccionado del buscador al form principal
            this.changeTaller(result.delegacion.toString());
          }
        }

      });
  }

  mostrarBuscadorPeticiones():void
  {
    const dialogRef = this.dialog.open(BuscarPeticionComponent,
        {
          data:{token:this.token, hojaprin: this}
        });

    dialogRef.afterClosed();
  }
  mostrarGestionPeticionWeb(tipo:string):void
  {
    const dialogRef = this.dialog.open(GestionPeticionWebComponent,
        {
          data:{token:this.token,tipo:tipo,form:this},
          maxWidth: '100%',
          height: 'auto'
        });

    dialogRef.afterClosed();
  }

  mostrarGestionPeticionAlp(tipo:string):void{
    const dialogRef = this.dialog.open(GestionPeticionAlpComponent,
        {
          data:{token:this.token,tipo:tipo,form:this},
          maxWidth: '100%',
          height: 'auto'
        });

    dialogRef.afterClosed();
  }

  mostrarDialogoAxa():void
  {
    this.dialog.open(AxaComponent,
        {
          data: { formularioHojas: this },
        }
    );
  }

  mostrarDialogoAbanca():void
  {
    this.dialog.open(AbancaComponent,
        {
          data: { formularioHojas: this },
        }
    );
  }

  mostrarDialogo(component:ComponentType<any>):void
  {
    this.dialog.open(component,
        {
          data: { formularioHojas: this },
        }
    );
  }

  cargarModelos(marca:string):void
  {
    if(marca.trim().length>0)
    {
      this.modelosDisponibles = [];
      this.articuloService.getModelosMarca(this.token,marca)
          .then(res=>
          {
            res.forEach
            (m =>
            {
              this.modelosDisponibles.push(m.modelo.trim())
            });
          })
          .catch(()=>
          {
            this.modelosDisponibles=["No disponible"];
          }).finally(
          () => {
            if(this.modeloSeleccionado != ''){
              this.vehiculo.modelo = this.modeloSeleccionado;
              this.modeloSeleccionado = '';
              this.checkAlert(this.vehiculo.modelo);
            }
          }
      );
    }
  }

  checkAlert(modelo:string):void{
    if(modelo.trim().length>0){
      const modeloLimpio = (modelo || '').trim().toUpperCase();
      const marcaLimpia = (this.vehiculo.marca || '').trim().toUpperCase();

      const modelosCitroen = ['C3', 'C4', 'DS3', 'DS4', 'DS5', 'C-ZERO'];
      const coincide = modelosCitroen.some(m =>
        modeloLimpio.includes(m.toUpperCase())
      );
      if(marcaLimpia === "CITROEN" && coincide) {
        this.tablas.getValoresTablas("AA", this.token,["dades"], ["codi", "asc"]).then(res => {
          if (res.length > 0) {
            const activeAlert = (res[0].dades.toString().trim() === "true");
            if (activeAlert) {
              this.mostrarArgumentario(
                "Atención", 
                [
                  "Vehículo con posible afección en el airbag. Confirme con el cliente si ha recibido una comunicación por parte de la DGT o de la marca para el cambio de airbag",
                  " ",
                  "Si el cliente la ha recibido la comunicación:",
                  "\u00A0\u00A0\u00A0 • Ha cambiado el airgbag: informarle de que deberá acudir al taller con el documento que acredite dicho cambio",
                  "\u00A0\u00A0\u00A0 • No lo ha cambiado: Abrir la HT con motivo “otros” indicando al taller esta situación. Informar al cliente de que dejamos abierto su servicio a la espera de que lo realice y pueda acudir a su cambio o reparación.",
                  " ",
                  "Si no lo sabe o no cree haber recibido nada:",
                  "\u00A0\u00A0\u00A0 Le invitamos a comprobarlo en el menú de la DGT y abrimos HT con normalidad y cita:",
                  "\u00A0\u00A0\u00A0 • Sede DGT: Vehículos → Consulta y modificación de los datos de un vehículo → Aviso de llamadas a revisión de un vehículo"
                ], false, true, true
              );
            }
          }
        });
      }
    }
  }
  cargarPuertas(anyio:number):void
  {
    if(this.vehiculo.modelo.trim().length>0 && this.vehiculo.marca.trim().length>0)
    {
      this.puertasVehiculo = [];
      this.articuloService.getPuertas(this.token,this.vehiculo.marca,this.vehiculo.modelo,anyio)
          .then(res=>{
            if(res.length>0)
            {
              res.forEach(a=>{this.puertasVehiculo.push(a)});
            }
          })
    }
  }

  async buscarMatricula()
  {
    if(this.vehiculo.matricula)
    {
      await this.getAccessTokenPromise();
      this.ocultarBuscaMatricula = false;

      this.albaranTallService.busquedaMatricula(this.token, this.vehiculo.matricula, this.extranjera)
          .then((res: { tipo: string, datos: Array<any> })=>
          {
            this.ocultarBuscaMatricula = true;
            if (Array.isArray(res) && res.length === 0)
            {
              this.mostrarArgumentario("No hay datos",["No se han encontrado datos con la matrícula " + this.vehiculo.matricula]);
              return;
            }
            else
            {
              let marca;
              let modelo;
              let bastidor;
              let fecMat;
              switch (res.tipo) {
                case "LISTADO":
                  this.dialog.open
                  (
                      BusquedaMatriculaComponent,
                      {
                        data:{listado:res.datos,form: this}
                      }
                  )
                      .afterClosed().subscribe
                  (
                      result=>
                      {
                        if(result != undefined && result != null && result != "")
                        {
                          //Asignar datos retornados al form principal
                          this.rellenarDeMatricula(result);
                          //reseteamos el case_id tambien
                          this.ResetCaseID();

                          this.checkAlert(this.vehiculo.modelo);
                        }
                      }
                  );
                  break;
                case "WS":
                  //Revisamos que la marca que nos llega esté en el listado de marcas disponibles
                  this.marcasDisponibles.includes(res.datos[0].marca.toString().trim())?
                  marca = res.datos[0].marca.toString().trim() : marca = "";
                  //marca==""?modelo="":modelo = res.datos[0].modelo.toString().trim();
                  if(marca=="")
                  {
                    modelo = "";
                    this.vehiculo.modelo = "";//Esto borra si esta seleccionado previamente
                  }
                  else
                  {
                    modelo = res.datos[0].modelo.toString().trim();
                  }
                  bastidor = res.datos[0].vin.toString().trim();
                  fecMat = res.datos[0].fecha_matricula.toString().split('T')[0];
                  this.rellenarMat(marca, modelo, bastidor, fecMat);
                  this.mostrarArgumentario("Información encontrada:",
                  [
                    "Marca: " + res.datos[0].marca.toString().trim(), "Modelo: " + res.datos[0].modelo.toString().trim(), "Bastidor: " + bastidor, "Matriculación: " + fecMat
                  ]);
                  break;
                case "DGT":
                  const datosParseados = res.datos as any;
                  //Revisamos que la marca que nos llega esté en el listado de marcas disponibles
                  this.marcasDisponibles.includes(datosParseados.Marca.trim())?
                  marca = datosParseados.Marca.trim() : marca = "";

                  if(marca=="")
                  {
                    modelo = "";
                    this.vehiculo.modelo = "";
                  }
                  else
                  {
                    modelo = datosParseados.Modelo.trim();
                  }
                  bastidor = datosParseados.Bastidor.trim();
                  fecMat = datosParseados['Fecha Matricula'] ? datosParseados['Fecha Matricula'] : '';
                  this.rellenarMat(marca, modelo, bastidor, fecMat);
                  this.mostrarArgumentario("Información encontrada:", [
                    "Marca: " + datosParseados.Marca.trim(),
                    "Modelo: " + datosParseados.Modelo.trim(),
                    "Bastidor: " + bastidor,
                    "Matriculación: " + fecMat
                  ]);
                  break;
              }

            }
          })
          .catch(err=>
          {
            this.ocultarBuscaMatricula = true;
            this.mostrarArgumentario("ERROR",[err.error], false, true, true);
          }).finally(() => {
            this.disableBtnGuardar = false;
      })
    }else{
      this.mostrarArgumentario("Atención", ["Debe de indicar la matrícula para proceder a la busqueda"], false, true, true);
    }
  }

  rellenarMat(marca:string, modelo:string, bastidor:string, matriculacion:string){
    this.vehiculo.marca= marca;
    this.modeloSeleccionado= modelo;
    this.vehiculo.any = matriculacion.substring(0, 4);
    if (this.vehiculo.marca != ''){
      this.cargarModelos(this.vehiculo.marca);
    }
    this.vehiculo.bastidor  = bastidor;
    this.vehiculo.matriculacion = matriculacion;
  }
  toUpperCaseMat(event: any) {
    event.target.value = event.target.value.toUpperCase();
    this.matriculaFormControl.setValue(event.target.value, { emitEvent: false });
  }
  //rellena los datos a partir del resultado de busqueda de matricula
  rellenarDeMatricula(datos:RBMatriculaMin)
  {
    datos.nif_per?this.asegurado.dni = datos.nif_per.toUpperCase().trim():this.asegurado.dni = this.asegurado.dni;
    datos.titular?this.asegurado.nombre = datos.titular.trim():this.asegurado.nombre;
    datos.dir_per?this.asegurado.dirCliente = datos.dir_per.trim():this.asegurado.dirCliente;
    datos.tel_per?this.asegurado.tel1 = datos.tel_per.trim():this.asegurado.tel1;
    //SOLO NOS INTERESA VOLCAR los datos de siniestro si es ABANCA
    if
    (
      this.ciaSeleccionada?.nombre.toUpperCase().includes("ABANCA")
      || this.llamada.entrada.includes("100000035")
    )
    {
      datos.siniestro?this.asegurado.siniestro = datos.siniestro.trim(): this.asegurado.siniestro;
    }
    //caso email cliente(el titular)
    if(datos.e_m_per!=""&&datos.e_m_per!=null)
    {
      this.asegurado.email = datos.e_m_per.trim();
      this.emailFacilitado = "si";
    }
    else{this.emailFacilitado = "no_tiene"}

    datos.repre?this.asegurado.agente=datos.repre.trim():this.asegurado.agente;//agente RLS
    datos.poliza?this.asegurado.poliza = datos.poliza.trim():this.asegurado.poliza;
    if (datos.fec_sin && datos.fec_sin != ""){
      this.asegurado.fecSin = datos.fec_sin
    }
    //datos.siniestro?this.asegurado.siniestro = datos.siniestro.trim():this.asegurado.siniestro.trim();
    datos.bastidor?this.vehiculo.bastidor = datos.bastidor.trim():this.vehiculo.bastidor;
    datos.km?this.vehiculo.km = datos.km.toString() : this.vehiculo.km;

    if(datos.marca && this.marcasDisponibles.includes(datos.marca.toString().trim()))
    {
      this.vehiculo.marca = datos.marca.toString().trim();
      datos.modelo?this.modeloSeleccionado= datos.modelo.trim():this.modeloSeleccionado;
    }
    else
    {
      this.vehiculo.marca = "";
      this.modeloSeleccionado="";
      //datos.marca?this.vehiculo.marca= datos.marca.trim():this.vehiculo.marca;
      //datos.modelo?this.modeloSeleccionado= datos.modelo.trim():this.modeloSeleccionado;
    }

    if (this.vehiculo.marca != ''){
      this.cargarModelos(this.vehiculo.marca);
    }
    if (datos.del && this.llamada.entrada) {
      this.onEntradaLlamadaSelected(this.llamada.entrada, datos.del.toString().trim().padStart(3, '0'));
    }else if(datos.del){
      this.mensajeObser = "Taller - " + datos.del.toString().trim();
    }
    //datos.cliente?this.auxCia=datos.cliente.trim():this.auxCia;
    /*if(this.mensajeObser == ""){
      datos.suc_lloc?this.mensajeObser = datos.suc_lloc.toString().trim(): this.mensajeObser;
    }else{
      datos.suc_lloc?this.mensajeObser = this.mensajeObser + "\r\n" + datos.suc_lloc.toString().trim(): this.mensajeObser;
    }*/
  }
  /*  si vienen datos de provincia desde otra parte
      por ejemplo de gestion web o de matricula,
      se gestiona qui los datos de Taller y CIA
  */

  /*
    si vienen datos de otra parte
    por ejemplo de gestion web o de matricula,
    se gestiona qui los datos de marca y modelo (y bastidor si lo pasan)
  */
  fillExternaMarca(marcaS:string, modeloS:string,bastidor?:string):void
  {
    this.vehiculo.marca = marcaS.trim().toUpperCase();
    this.vehiculo.modelo = modeloS.trim().toUpperCase();
    bastidor?this.vehiculo.bastidor = bastidor : this.vehiculo.bastidor=this.vehiculo.bastidor;
  }

  quitarArticulo(artSeleccionado:ArticuloContact)
  {
    let oldArt = artSeleccionado.articulo;//articulo que quitaremos

    if(GestionArticulo.esManoObra(oldArt,this.manoObraArticulos))
    {
      //es una mano de obra, informamos que no puede quitarse de forma manual
      this.mostrarArgumentario("Artículo restringido",["El artículo es mano de obra.","La mano de obra no se puede quitar de manera manual"], false, true, true);
      return;
    }else{
      //const index = this.artsSeleccionados.findIndex((element) => element === artSeleccionado);
      const index = this.artsSeleccionados.findIndex((element) =>
        element.articulo === artSeleccionado.articulo &&
        this.truncateString(element.desc) === this.truncateString(artSeleccionado.desc)
      );
      if (index > -1)
      {
        if(!["99000001","99001001","99001002"].includes(artSeleccionado.articulo)){
          this.auxRepa = this.auxRepa-1;
        }
        //buscamos y quitamos la Mano de obra del articulo
        GestionArticulo.quitarManoObra(oldArt,this.manoObraArticulos,this.artsSeleccionados);
        //quitamos el articulo seleccionado
        this.artsSeleccionados.splice(index,1);
        //actualizamos el datasource
        this.artsSeleccionadosSource.data = this.artsSeleccionados;
      }
    }

  }
  //gestiona el proceso de agregar un articulo en el listado de articulos
  agregarArticulo(articulo:ArticuloContact, tipo: boolean = false)
  {
    
    if (GestionArticulo.estaSeleccionado(articulo.articulo, this.artsSeleccionados)) {
      return; // Ya existe → no insertar
    }

    if (tipo){
      this.artsSeleccionados.push(articulo);
      if(!["99000001","99001001","99001002"].includes(articulo.articulo)){
        this.auxRepa = this.auxRepa+1;
      }
      this.bookingArticulos.push(articulo);
      this.artsSeleccionadosSource = new MatTableDataSource(this.artsSeleccionados);
    }else{
      if(!GestionArticulo.estaSeleccionado(articulo.articulo, this.artsSeleccionados)){
        this.artsSeleccionados.push(articulo);
        if(!["99000001","99001001","99001002"].includes(articulo.articulo)){
          this.auxRepa = this.auxRepa+1;
        }

        this.clienteService.getPrecioNeto(this.token,this.tallerSeleccionado!.delegacion.toString(),
          this.ciaSeleccionada!.cliente.toString().trim(), articulo.articulo).then(
            res => {
              if(!res){
                GestionArticulo.gestionManoObra(this.articuloService,this.token,articulo.articulo)
                  .then(res=>
                  {
                    if(res && typeof res === 'object' && Object.keys(res).length > 0){
                      //Revisamos si se debe agregar el articulo de Mano de obra
                      this.artsSeleccionados = GestionArticulo.agregarManoObra(this.artsSeleccionados,res);

                      //Agregamos al listado de articulo+MO este par:
                      this.manoObraArticulos.push({articulo:articulo.articulo,manoObra:res.articulo});
                    }
                  })
                  .catch(err=>{
                    console.error(err)
                  }).finally(() => {this.artsSeleccionadosSource = new MatTableDataSource(this.artsSeleccionados);});
              }
            }
        );
      }
    }
  }

  checkCampa(){
    let taller = (this.tallerSeleccionado?.delegacion?.toString() || "").trim();
    let cliente = (this.ciaSeleccionada?.cliente?.toString() || "").trim();
    let piloto = (this.llamada.entrada?.toString() || "").trim();
    this.rls.getCampas(this.token, parseInt(taller).toString(), cliente, piloto).then(res => {
      if (res.length > 0){
        this.auxCampaCC = res[0].nombre
        if(CampasFunctions.checkCampa(piloto, cliente, taller, res, this.artsSeleccionados, this)){
          this.campaContactRls = this.auxCampaCC;
          this.campanaArticulos.forEach(art => {
            let existe = this.artsSeleccionados.some(a => a.articulo?.toString().trim() === art.articulo?.toString().trim());
            if(!existe){
              PilotosFunctions.addArticulo(this, art.articulo, art.desc, true);
            }
          });
        }
      }else{
        this.showCampa = false;
        if(this.checkArrayCampana()){
          this.campaContactRls = "";
          this.quitarArticulo(this.campanaArticulos[0]);
        }
      }
    });
  }

 addCampa(){
    if(!this.checkArrayCampana()){
      this.campaContactRls = this.auxCampaCC;
      this.campanaArticulos.forEach(art => {
        let existe = this.artsSeleccionados.some(a => a.articulo?.toString().trim() === art.articulo?.toString().trim());
        if(!existe){
          PilotosFunctions.addArticulo(this, art.articulo, art.desc, true);
        }
      });
    }
  }

  checkArrayCampana() {
    return this.artsSeleccionados.some(item =>
      item.articulo === this.campanaArticulos[0].articulo &&
      this.truncateString(item.desc) === this.truncateString(this.campanaArticulos[0].desc)
    );
  }

  truncateString(str: string): string {
    if (!str) return '';
    const maxLength = 39;
    const truncated = str.length > maxLength ? str.substring(0, maxLength) : str;
    return truncated.trim();
  }

  abirBuscadorPrisma():void
  {
    if(!this.vehiculo.marca || !this.vehiculo.modelo  || !this.vehiculo.matricula || !this.tallerSeleccionado || !this.ciaSeleccionada){
      this.mostrarArgumentario("Atención!",[
        "Debe de indicar los siguientes campos para poder abrir el buscador: ",
        "- Taller",
        "- Compañia",
        "- Matricula",
        "- Marca",
        "- Modelo"
      ], false, true, true);
    }else{
      this.callBookingUrl("damage-assessment");
    }
  }

  cargarVentanaAgendaNueva():void
  {
    if(!this.ciaSeleccionada?.cliente)
    {
      let dialog = this.mostrarArgumentarioRes("Atención!", ["Para una mejor selección de cita, seleccionar la compañia. Muchas gracias"]);
      dialog.subscribe(() => {
        this.callBookingUrl("agenda");
      });
    }else{
      this.callBookingUrl("agenda");
    }
  }

  callBookingUrl(typeUrl: string){
    let model=this.vehiculo.modelo.toString().trim()
    let manufacturer=this.vehiculo.marca.toString().trim()
    let modelYear=this.vehiculo.any.toString().trim()
    let vin=this.vehiculo.bastidor.toString().trim()
    let regno= this.vehiculo.matricula.toString().trim()
    //let vehicleType= "car"
    let clientId = this.ciaSeleccionada?.cliente.toString().trim() ?? "";
    let referrer = window.location.protocol + "//" + window.location.host;
    let taller = Number(this.tallerSeleccionado?.delegacion.toString().trim())
    
    let url = `${environment.bookingPlataform}${typeUrl}?` +
      `vin=${encodeURIComponent(vin)}` +
      `&workshopId=${encodeURIComponent(taller)}` +
      `&manufacturer=${encodeURIComponent(manufacturer)}` +
      `&model=${encodeURIComponent(model)}` +
      `&modelYear=${encodeURIComponent(modelYear)}` +
      `&regno=${encodeURIComponent(regno)}` +
      `&referrer=${encodeURIComponent(referrer)}` +
      `&clientId=${encodeURIComponent(clientId)}` +
      `&caseId=${encodeURIComponent(this.caseID || '')}`;
    let popUp =  window.open(url,"popup","width=990,height=900");

    const messageHandler = (event: MessageEvent) => {
      if (event.origin !== environment.bookingPlatformOrigin) return;

      try {
        popUp?.close();
        switch (event.data.type) {
          case "damageSpecification":
            let descripcionDano = "";
            if(this.caseID != event.data.caseID && this.caseID != ""){
              this.stopIntervalGetArticulo();
            }
            this.caseID = event.data.caseId;
            this.danosPrismaCodigos = [];
            let countTrabajos = 0;
            for (let i = 0; i < event.data.damages.length; i++) {
              let position = event.data.damages[i].position.toString().trim().toUpperCase();
              let type = event.data.damages[i].serviceType.toString().trim().toUpperCase();
              const codigo = `${position} ${type}`;
              this.danosPrismaCodigos.push(codigo);
              // Traduccion por daccionario como position "espacio" y type.
              descripcionDano += this.diccionarioTraduccionCristal[codigo];
              countTrabajos += 1;
              if (i < event.data.damages.length - 1) {
                descripcionDano += " + ";
              }
            }
            const esMultiple = countTrabajos > 1;
            const incluyeReparacion = descripcionDano.includes('REPARACIÓN');

            this.trabajoSeleccionado = descripcionDano;

            if (esMultiple && !incluyeReparacion) {
              this.trabajoSeleccionado = 'SUSTITUCIÓN MÚLTIPLE';
            } else if (esMultiple && incluyeReparacion) {
              if (countTrabajos === 2 && descripcionDano.length > 70) {
                this.trabajoSeleccionado = 'REPARACIÓN Y SUSTITUCIÓN';
              } else if (countTrabajos > 2) {
                this.trabajoSeleccionado = 'REPARACIÓN Y SUSTITUCIÓN MÚLTIPLE';
              }
            }
            this.insertPayloadBooking(event.data, "CC_Selector_Dano");
            this.intervalGetArticulo();
            break;
          case "appointment":
            const now = new Date();
            const target = new Date(event.data.appointment.reservedUntil);
            const differenceMs = target.getTime() - now.getTime();
            this.fechaCitaBooking = event.data.appointment.date.toString().trim();
            this.horaCitaBooking = event.data.appointment.time.toString().trim();
            this.pickupDateBooking = event.data.appointment.pickup.toString().trim();
            this.tieneCitaReservada = true;
            this.insertPayloadBooking(event.data, "CC_Agenda");
            this.talleresDisponiblesControl.disable(); 
            this.intervalFechaReservada(differenceMs);
            this.mostrarArgumentario("Atención!", [
                "La cita ha sido reservada correctamente.",
                "No puedes cambiar de taller hasta que anules la cita."
              ]);
            break;
          case "cancelAppointment":  
            this.tieneCitaReservada = false;
            this.fechaCitaBooking = "";
            this.horaCitaBooking = "";
            this.pickupDateBooking = "";
            this.talleresDisponiblesControl.enable(); 
            this.insertPayloadBooking(event.data, "CC_CancelCita");
            this.mostrarArgumentario("Atención!", [
              "La cita ha sido anulada correctamente.",
              "Ya puedes seleccionar otro taller si lo deseas."
            ]);
            break;

          default:
            console.warn("Tipo de evento desconocido:", event.data.type);
        }
      } catch (err: any) {
        console.error("Error al procesar el evento:", err);
        this.mostrarArgumentario("Error al recoger payload", [err.error], false, true, true);
      } finally {
        window.removeEventListener("message", messageHandler);
      }
    };

    window.addEventListener("message", messageHandler, { once: false });
  }

  insertPayloadBooking(payload: any, origen:string){
    const query = {
      taller: this.tallerSeleccionado!.delegacion,
      hoja: 0,
      case_id: this.caseID,
      payload: JSON.stringify(payload),
      origen: origen
    };

    this.bookingService.insertPayload(this.token, query).then(
      res =>{
        console.log(res);
      }
    ).catch(err=>
    {
      console.log(err);
    });
  }

  //Funcion para iniciar el polling de artículos
  intervalGetArticulo() {
    if (this.pollingActivo) return; // evita duplicados
    this.stopFlag = false;
    this.pollingActivo = true;

    const tryGetArticulo = async () => {
      if (this.stopFlag) { this.pollingActivo = false; return; }

      try {
        const res = await this.bookingService.buscarArticuloPayload(this.token, this.caseID);
        if (Array.isArray(res) && res.length > 0) {
          for (const item of res) {
            await PilotosFunctions.addArticulo(this, item.articulo, item.desc, false, item.eurocode, true);
          }
          // no reprogramamos -> se detiene solo
          this.pollingActivo = false;
        } else {
          this.pollTimeoutId = setTimeout(tryGetArticulo, 10_000);
        }
      } catch (err) {
        this.mostrarArgumentario('Error', ["Error al obtener los articulos de Prisma"], false, true, true);
        this.pollTimeoutId = setTimeout(tryGetArticulo, 10_000);
      }
    };

    tryGetArticulo();
  }

  //Funcion para detener el polling de artículos
  stopIntervalGetArticulo() {
    console.log("Deteniendo polling de artículos...");
    if (this.stopFlag && !this.pollingActivo && this.pollTimeoutId === null) return false;

    this.stopFlag = true;                 // evita reprogramar más timeouts
    if (this.pollTimeoutId !== null) {
      clearTimeout(this.pollTimeoutId);   // no-op si ya estaba limpio
      this.pollTimeoutId = null;
    }
    this.pollingActivo = false;
    return true;      
  }

  intervalFechaReservada(milisegundos: number){
    const intervalCita = setInterval(() => {
      let payload = {
        type: "expiredAppointment",
        caseId: this.caseID,
        appointment: {
          date: this.fechaCitaBooking,
          time: this.horaCitaBooking,
          utcAppointment: ""
        },
        callbackUri: ""
      }
      this.fechaCitaBooking = "";
      this.horaCitaBooking = "";
      this.tieneCitaReservada = false;
      this.insertPayloadBooking(payload, "CC_ExpiredCita");
      this.mostrarArgumentario("Atención!", ["Ha expirado el tiempo de reserva de la cita.", "Por favor, vuelva a abrir 'Agendar Cita' y seleccione de nuevo una cita."]);
      clearInterval(intervalCita);
    }, milisegundos);
  }
  /*
    Verifica si la fecha de la cita es menor a 5 días a partir de hoy.
    Tambien por petición de ultima hora de Victor,
    se debe de revisar por horas.
    120 horas = 5 días
  */
  private FechaMenorDe5Dias(): boolean 
  {
    // Pillamos la fecha actual y la de la cita
    const ahora = new Date();
    const fechaObjetivo = new Date(this.fechaCitaBooking);

    // Si la fecha objetivo es anterior a ahora, devolvemos false
    if (fechaObjetivo <= ahora) return false;

    let fechaTemp = new Date(ahora);
    let horasLaborables = 0;

    // Recorremos cada hora entre ahora y la fecha objetivo
    while (fechaTemp < fechaObjetivo) 
    {
      const diaSemana = fechaTemp.getDay();
      // 0: domingo, 6: sábado
      if (diaSemana !== 0 && diaSemana !== 6) 
      {
        horasLaborables++;
      }
      fechaTemp.setHours(fechaTemp.getHours() + 1);
    }
    console.log(`Hay una diferencia de ${horasLaborables} horas laborables`);
    return horasLaborables < 120;
  }

  //Resetea el case_id.
  //Se debe usar para cuando haya algún proceso que requiera oblgatoriamente un nuevo case_id
  public ResetCaseID(){this.caseID = ""; this.danosPrismaCodigos = []; this.stopIntervalGetArticulo();} 
}